import get from 'lodash/get'
import {
  addOffset,
  getUtcDate,
  isBefore,
  isDateBetween,
  convertIn12HoursFormat,
  isSameOrBefore,
  convertDateTo_YYYY_MM_DD
} from './dateUtil'
import {
  VISITOR_LIST,
  DASHBOARD_MODULE,
  SECURITY_OFFICER_DESIGNATION,
  SecurityAdmin,
  SHORE_SIDE_SECURITY_ADMIN,
  ApproverRole,
  OFFICE_ADMIN,
  RequestorRole,
  APP_AUTH_NAME,
  authHandlerObject,
  VIP_BOARDING_NUMBER,
  EXPORT_BOARDING_SLOT_HISTORY_REPORT_URL,
  EXPORT_GUEST_FLIGHT_DETAILS_REPORT_URL,
  CBP_MESSAGE_SCHEDULE_URL,
  CBP_VCO_MESSAGE_URL,
  CBP_LATEST_ENOAD_URL,
  CBP_GET_LEGS_URL,
  CBP_SEND_VCO_MESSAGE_URL,
  CBP_SEND_BATCH_MESSAGE_URL,
  CBP_GENERATE_ENOAD_BATCH_URL,
  CBP_DOWNLOAD_ENOAD_URL,
  CBP_COMPARATOR_URL,
  PERSON_TYPES_ROUTE,
  PERSON_CREW_ID,
  PERSON_VISITOR_ID,
  docTypes,
  EXPORT_BOARDING_SLOT_REPORT_URL,
  PERSON_RESERVATION_GUEST_ID,
  EXPORT_DOC_TYPE_BREAKDOWN_URL,
  EXPORT_DOC_WISE_SAILOR_URL,
  EXPORT_SAILOR_NATIONALITY_URL,
  EXPORT_NATIONALITY_WISE_SAILOR_URL,
  rtsStatusCodes,
  cruiseContractStatusLabels,
  mociStatusCodes,
  visaEntriesCodes,
  DOCUMENT_TYPE_VISA
} from '../constants'
import routes from '../constants/routes'
import uniqBy from 'lodash/uniqBy'
import {
  LOGIN_URL,
  VISITOR_MEDIA_URL,
  RESERVATION_GUEST_LIST,
  LOGS,
  UI_CONFIG,
  GLOBAL_SEARCH,
  STATEROOMS_LIST,
  RESOURCES,
  SLOTS,
  RESERVATION_GUESTS_SEARCH,
  LOCATION_REPORT,
  IPM_SINGLE_ASSIGN,
  IPM_SINGLE_UNASSIGN,
  VISITOR_IMPORT,
  GUESTTYPES_URL,
  CREATE_RESERVATION_URL,
  IPM_IMPORT_URL,
  IPM_PERCENTAGE_CONFIG_IMPORT_URL,
  STATEROOMS_SEARCH,
  RESERVATIONGUESTS_SEARCH,
  GET_GUESTRESERVATION,
  GET_STATEROOMCATEGORIES,
  GET_STATEROOMCAPACITIES,
  POST_STATEROOMSTATUS,
  RESERVATION_GUESTS,
  GUEST_STATEROOMPARTY_URL,
  GUEST_SEARCHPARTY_URL,
  UPGRADE_STATEROOM_URL,
  VOYAGES_URL,
  RESERVATIONGUESTS_BATCHURL,
  RESERVATION_GUESTUPDATE_URL,
  ALERTMESSAGE_DETAILURL,
  PERSONDETAILS_GET,
  ATTRIBUTE_URL,
  ALERT_REPORT_URL,
  EXPORT_VISITOR_URL,
  EXPORT_LOCATION_HISTORY_REPORT_URL,
  UPDATE_MASTER_DATA_URL,
  BOARDING_EXCEPTION_REPORT_URL,
  SAILOR_VIP_ICONS_URL,
  PRIORITY_BOARDING_NUMBER,
  SW_FARE_CODE_ALLOWLIST
} from '../constants'

import dxpLightMessageIcon from './../images/dxp-light/message.svg'
import dxpLightconcerirgeIcon from './../images/dxp-light/concerirge.svg'
import dxpLightcalendarIcon from './../images/dxp-light/calendar.svg'
import dxpLightcrewIcon from './../images/dxp-light/crew.svg'
import dxpLightdashboardIcon from './../images/dxp-light/dashboard.svg'
import dxpLightdropdownIcon from './../images/dxp-light/dropdown.svg'
import dxpLightdownloadIcon from './../images/dxp-light/download.svg'
import dxpLightfilterIcon from './../images/dxp-light/filter.svg'
import dxpLightguestIcon from './../images/dxp-light/guest.svg'
import dxpLighthamburgerIcon from './../images/dxp-light/hamburger.svg'
import dxpLightmoreIcon from './../images/dxp-light/more.svg'
import dxpLightpdfIcon from './../images/dxp-light/pdf.svg'
import dxpLightdeleteIcon from './../images/dxp-light/delete.svg'
import dxpLightprintIcon from './../images/dxp-light/print.svg'
import dxpLightreportsIcon from './../images/dxp-light/reports.svg'
import dxpLightsearchIcon from './../images/dxp-light/search.svg'
import dxpLighttxtIcon from './../images/dxp-light/txt.svg'
import dxpLightvisitorsIcon from './../images/dxp-light/visitors.svg'
import dxpLightchevronIcon from './../images/dxp-light/chevron.svg'
import dxpLightsortIcon from './../images/dxp-light/sort.svg'
import dxpLightsortedIcon from './../images/dxp-light/sorted.svg'
import dxpLighttickIcon from './../images/dxp-light/tick.svg'
import dxpLighthandicapIcon from './../images/dxp-light/handicap.svg'
import dxpLightcommonIcon from './../images/dxp-light/common.svg'
import dxpLightopenFiltersIcon from './../images/dxp-light/open-filters.svg'
import dxpLightAddIcon from './../images/dxp-light/add.svg'
import dxpLightMinusIcon from './../images/dxp-light/minus.svg'
import dxpLightInformationIcon from './../images/dxp-light/information.svg'
import dxpLightWarningIcon from './../images/dxp-light/warning.svg'
import dxpLightrefreshIcon from './../images/dxp-light/refresh.svg'
import dxpLightCabinIcon from './../images/dxp-light/cabin.svg'
import dxpLightSettingsIcon from './../images/dxp-light/settings.svg'
import dxpLightIpmIcon from './../images/dxp-light/ipm.svg'
import dxpLightApprovedItemIcon from './../images/dxp-light/approved-item.svg'
import dxpLightPendingItemIcon from './../images/dxp-light/pending-item.svg'
import dxpLightRejectedItemIcon from './../images/dxp-light/rejected-item.svg'
import dxpLightRemoveItemIcon from './../images/dxp-light/remove.svg'
import dxpLighteditItemIcon from './../images/dxp-light/edit.svg'
import dxpLightLoaderItemIcon from './../images/dxp-light/loader.svg'
import dxpLighttransitionItemIcon from './../images/dxp-light/transition.svg'
import dxpLightLoginBg from './../images/dxp-light/login_bg.jpg'
import dxpLightNoShipBg from './../images/dxp-light/no-ship.jpg'
import dxpLightBoardingSlot from './../images/dxp-light/boarding-slot.svg'
import dxpLightArrowLeftIcon from './../images/dxp-light/arrow-left.svg'
import dxpLightArrowRightIcon from './../images/dxp-light/arrow-right.svg'
import dxpLightBirthdayIcon from './../images/dxp-light/birthday.svg'
import dxpLightServiceDogIcon from './../images/dxp-light/service-dog.svg'
import dxpLighttimeIcon from './../images/dxp-light/time.svg'
import dxpLightStateroomIcon from './../images/dxp-light/stateroom.svg'
import dxpLightGoldIcon from './../images/dxp-light/gold.svg'
import dxpLightNewIcon from './../images/dxp-light/new.svg'
import dxpLightPotentialIcon from './../images/dxp-light/potential.svg'
import dxpLightPlatinumIcon from './../images/dxp-light/platinum.svg'
import dxpLightSilverIcon from './../images/dxp-light/silver.svg'
import dxpLightAlertRedIcon from './../images/dxp-light/alert-red.svg'
import dxpLightPrimaryGuestIcon from './../images/dxp-light/primary-guest.svg'
import dxpLightInfoAlertIcon from './../images/dxp-light/info-alert.svg'
import dxpLightMasterBoardingIcon from './../images/dxp-light/master-boarding.svg'
import dxpLightPearlIcon from './../images/dxp-light/Pearl.svg'

import dxpDarkMessageIcon from './../images/dxp-dark/message.svg'
import dxpDarkconcerirgeIcon from './../images/dxp-dark/concerirge.svg'
import dxpDarkcalendarIcon from './../images/dxp-dark/calendar.svg'
import dxpDarkdeleteIcon from './../images/dxp-dark/delete.svg'
import dxpDarkcrewIcon from './../images/dxp-dark/crew.svg'
import dxpDarkdashboardIcon from './../images/dxp-dark/dashboard.svg'
import dxpDarkdropdownIcon from './../images/dxp-dark/dropdown.svg'
import dxpDarkdownloadIcon from './../images/dxp-dark/download.svg'
import dxpDarkfilterIcon from './../images/dxp-dark/filter.svg'
import dxpDarkguestIcon from './../images/dxp-dark/guest.svg'
import dxpDarkhamburgerIcon from './../images/dxp-dark/hamburger.svg'
import dxpDarkmoreIcon from './../images/dxp-dark/more.svg'
import dxpDarkpdfIcon from './../images/dxp-dark/pdf.svg'
import dxpDarkprintIcon from './../images/dxp-dark/print.svg'
import dxpDarkreportsIcon from './../images/dxp-dark/reports.svg'
import dxpDarksearchIcon from './../images/dxp-dark/search.svg'
import dxpDarktxtIcon from './../images/dxp-dark/txt.svg'
import dxpDarkvisitorsIcon from './../images/dxp-dark/visitors.svg'
import dxpDarkchevronIcon from './../images/dxp-dark/chevron.svg'
import dxpDarksortIcon from './../images/dxp-dark/sort.svg'
import dxpDarksortedIcon from './../images/dxp-dark/sorted.svg'
import dxpDarktickIcon from './../images/dxp-dark/tick.svg'
import dxpDarkhandicapIcon from './../images/dxp-dark/handicap.svg'
import dxpDarkcommonIcon from './../images/dxp-dark/common.svg'
import dxpDarkopenFiltersIcon from './../images/dxp-dark/open-filters.svg'
import dxpDarkAddIcon from './../images/dxp-dark/add.svg'
import dxpDarkMinusIcon from './../images/dxp-dark/minus.svg'
import dxpDarkInformationIcon from './../images/dxp-dark/information.svg'
import dxpDarkWarningIcon from './../images/dxp-dark/warning.svg'
import dxpDarkrefreshIcon from './../images/dxp-dark/refresh.svg'
import dxpDarkCabinIcon from './../images/dxp-dark/cabin.svg'
import dxpDarkSettingsIcon from './../images/dxp-dark/settings.svg'
import dxpDarkIpmIcon from './../images/dxp-dark/ipm.svg'
import dxpDarkApprovedItemIcon from './../images/dxp-dark/approved-item.svg'
import dxpDarkPendingItemIcon from './../images/dxp-dark/pending-item.svg'
import dxpDarkRejectedItemIcon from './../images/dxp-dark/rejected-item.svg'
import dxpDarkRemoveItemIcon from './../images/dxp-dark/remove.svg'
import dxpDarkeditItemIcon from './../images/dxp-dark/edit.svg'
import dxpDarkLoaderItemIcon from './../images/dxp-dark/loader.svg'
import dxpDarktransitionItemIcon from './../images/dxp-dark/transition.svg'
import dxpDarkLoginBg from './../images/dxp-dark/login_bg.jpg'
import dxpDarkNoShipBg from './../images/dxp-dark/no-ship.jpg'
import dxpDarkBoardingSlot from './../images/dxp-dark/boarding-slot.svg'
import dxpDarkArrowLeftIcon from './../images/dxp-dark/arrow-left.svg'
import dxpDarkArrowRightIcon from './../images/dxp-dark/arrow-right.svg'
import dxpDarkBirthdayIcon from './../images/dxp-dark/birthday.svg'
import dxpDarkServiceDogIcon from './../images/dxp-dark/service-dog.svg'
import dxpDarktimeIcon from './../images/dxp-light/time.svg'
import dxpDarkStateroomIcon from './../images/dxp-dark/stateroom.svg'
import dxpDarkGoldIcon from './../images/dxp-dark/gold.svg'
import dxpDarkNewIcon from './../images/dxp-dark/new.svg'
import dxpDarkPotentialIcon from './../images/dxp-dark/potential.svg'
import dxpDarkPlatinumIcon from './../images/dxp-dark/platinum.svg'
import dxpDarkSilverIcon from './../images/dxp-dark/silver.svg'
import dxpDarkAlertRedIcon from './../images/dxp-dark/alert-red.svg'
import dxpDarkPrimaryGuestIcon from './../images/dxp-dark/primary-guest.svg'
import dxpDarkInfoAlertIcon from './../images/dxp-dark/info-alert.svg'
import dxpDarkMasterBoardingIcon from './../images/dxp-dark/master-boarding.svg'
import dxpDarkPearlIcon from './../images/dxp-dark/Pearl.svg'

import vvLightMessageIcon from './../images/vv-light/message.svg'
import vvLightconcerirgeIcon from './../images/vv-light/concerirge.svg'
import vvLightcalendarIcon from './../images/vv-light/calendar.svg'
import vvLightcrewIcon from './../images/vv-light/crew.svg'
import vvLightdashboardIcon from './../images/vv-light/dashboard.svg'
import vvLightdropdownIcon from './../images/vv-light/dropdown.svg'
import vvLightdownloadIcon from './../images/vv-light/download.svg'
import vvLightfilterIcon from './../images/vv-light/filter.svg'
import vvLightguestIcon from './../images/vv-light/guest.svg'
import vvLighthamburgerIcon from './../images/vv-light/hamburger.svg'
import vvLightmoreIcon from './../images/vv-light/more.svg'
import vvLightpdfIcon from './../images/vv-light/pdf.svg'
import vvLightprintIcon from './../images/vv-light/print.svg'
import vvLightreportsIcon from './../images/vv-light/reports.svg'
import vvLightsearchIcon from './../images/vv-light/search.svg'
import vvLighttxtIcon from './../images/vv-light/txt.svg'
import vvLightvisitorsIcon from './../images/vv-light/visitors.svg'
import vvLightchevronIcon from './../images/vv-light/chevron.svg'
import vvLightDeleteIcon from './../images/vv-light/delete.svg'
import vvLightsortIcon from './../images/vv-light/sort.svg'
import vvLightsortedIcon from './../images/vv-light/sorted.svg'
import vvLighttickIcon from './../images/vv-light/tick.svg'
import vvLightCircletickIcon from './../images/vv-light/circletick.svg'
import vvLightCoordinateIcon from './../images/vv-light/coordinate.svg'
import vvLightWarningIcon from './../images/vv-light/warning.svg'
import vvLighthandicapIcon from './../images/vv-light/handicap.svg'
import vvLightcommonIcon from './../images/vv-light/common.svg'
import vvLightopenFiltersIcon from './../images/vv-light/open-filters.svg'
import vvLightAddIcon from './../images/vv-light/add.svg'
import vvLightMinusIcon from './../images/vv-light/minus.svg'
import vvLightInformationIcon from './../images/vv-light/information.svg'
import vvLightrefreshIcon from './../images/vv-light/refresh.svg'
import vvLightCabinIcon from './../images/vv-light/cabin.svg'
import vvLightSettingsIcon from './../images/vv-light/settings.svg'
import vvLightIpmIcon from './../images/vv-light/ipm.svg'
import vvLightApprovedItemIcon from './../images/vv-light/approved-item.svg'
import vvLightPendingItemIcon from './../images/vv-light/pending-item.svg'
import vvLightRejectedItemIcon from './../images/vv-light/rejected-item.svg'
import vvLightRemoveItemIcon from './../images/vv-light/remove.svg'
import vvLighteditItemIcon from './../images/vv-light/edit.svg'
import vvLightLoaderItemIcon from './../images/vv-light/loader.gif'
import vvLighttransitionItemIcon from './../images/vv-light/transition.svg'
import vvLightLoginBg from './../images/vv-light/login_bg.png'
import vvLightNoShipBg from './../images/vv-light/no-ship.jpg'
import vvLightBoardingSlot from './../images/vv-light/boarding-slot.svg'
import vvLightArrowLeftIcon from './../images/vv-light/arrow-left.svg'
import vvLightArrowRightIcon from './../images/vv-light/arrow-right.svg'
import vvLightBirthdayIcon from './../images/vv-light/birthday.svg'
import vvLightServiceDogIcon from './../images/vv-light/service-dog.svg'
import vvLighttimeIcon from './../images/dxp-light/time.svg'
import vvLightMasterBoardingIcon from './../images/vv-light/master-boarding.svg'
import vvLightPearlIcon from './../images/vv-light/Pearl.svg'
import vvLightMotorizedScooterIcon from './../images/vv-light/motorized-scooter.svg'
import vvLightSlotFlagIcon from './../images/vv-light/slot-flag.svg'
import vvLightAlertRedIcon from './../images/vv-light/alert-red.svg'

import vvDarkMessageIcon from './../images/vv-dark/message.svg'
import vvDarkconcerirgeIcon from './../images/vv-dark/concerirge.svg'
import vvDarkcalendarIcon from './../images/vv-dark/calendar.svg'
import vvDarkcrewIcon from './../images/vv-dark/crew.svg'
import vvDarkdashboardIcon from './../images/vv-dark/dashboard.svg'
import vvDarkdropdownIcon from './../images/vv-dark/dropdown.svg'
import vvDarkdownloadIcon from './../images/vv-dark/download.svg'
import vvDarkfilterIcon from './../images/vv-dark/filter.svg'
import vvDarkguestIcon from './../images/vv-dark/guest.svg'
import vvDarkhamburgerIcon from './../images/vv-dark/hamburger.svg'
import vvDarkmoreIcon from './../images/vv-dark/more.svg'
import vvDarkpdfIcon from './../images/vv-dark/pdf.svg'
import vvDarkprintIcon from './../images/vv-dark/print.svg'
import vvDarkreportsIcon from './../images/vv-dark/reports.svg'
import vvDarksearchIcon from './../images/vv-dark/search.svg'
import vvDarktxtIcon from './../images/vv-dark/txt.svg'
import vvDarkvisitorsIcon from './../images/vv-dark/visitors.svg'
import vvDarkchevronIcon from './../images/vv-dark/chevron.svg'
import vvDarkDeleteIcon from './../images/vv-dark/delete.svg'
import vvDarksortIcon from './../images/vv-dark/sort.svg'
import vvDarksortedIcon from './../images/vv-dark/sorted.svg'
import vvDarktickIcon from './../images/vv-dark/tick.svg'
import vvDarkCircletickIcon from './../images/vv-dark/circletick.svg'
import vvDarkWarningIcon from './../images/vv-dark/warning.svg'
import vvDarkCoordinateIcon from './../images/vv-dark/coordinate.svg'
import vvDarkhandicapIcon from './../images/vv-dark/handicap.svg'
import vvDarkcommonIcon from './../images/vv-dark/common.svg'
import vvDarkopenFiltersIcon from './../images/vv-dark/open-filters.svg'
import vvDarkAddIcon from './../images/vv-dark/add.svg'
import vvDarkMinusIcon from './../images/vv-dark/minus.svg'
import vvDarkInformationIcon from './../images/vv-dark/information.svg'
import vvDarkrefreshIcon from './../images/vv-dark/refresh.svg'
import vvDarkCabinIcon from './../images/vv-dark/cabin.svg'
import vvDarkSettingsIcon from './../images/vv-dark/settings.svg'
import vvDarkIpmIcon from './../images/vv-dark/ipm.svg'
import vvDarkApprovedItemIcon from './../images/vv-dark/approved-item.svg'
import vvDarkPendingItemIcon from './../images/vv-dark/pending-item.svg'
import vvDarkRejectedItemIcon from './../images/vv-dark/rejected-item.svg'
import vvDarkRemoveItemIcon from './../images/vv-dark/remove.svg'
import vvDarkeditItemIcon from './../images/vv-dark/edit.svg'
import vvDarkLoaderItemIcon from './../images/vv-dark/loader.gif'
import vvDarktransitionItemIcon from './../images/vv-dark/transition.svg'
import vvDarkLoginBg from './../images/vv-dark/login_bg.png'
import vvDarkNoShipBg from './../images/vv-dark/no-ship.jpg'
import vvDarkBoardingSlot from './../images/vv-dark/boarding-slot.svg'
import vvDarkArrowLeftIcon from './../images/vv-dark/arrow-left.svg'
import vvDarkArrowRightIcon from './../images/vv-dark/arrow-right.svg'
import vvDarkBirthdayIcon from './../images/vv-dark/birthday.svg'
import vvDarkServiceDogIcon from './../images/vv-dark/service-dog.svg'
import vvDarktimeIcon from './../images/dxp-light/time.svg'
import vvDarkMasterBoardingIcon from './../images/vv-dark/master-boarding.svg'
import vvDarkPearlIcon from './../images/vv-dark/Pearl.svg'
import vvDarkAlertRedIcon from './../images/vv-dark/alert-red.svg'

import nclLightMessageIcon from './../images/ncl-light/message.svg'
import nclLightconcerirgeIcon from './../images/ncl-light/concerirge.svg'
import nclLightcalendarIcon from './../images/ncl-light/calendar.svg'
import nclLightcrewIcon from './../images/ncl-light/crew.svg'
import nclLightdashboardIcon from './../images/ncl-light/dashboard.svg'
import nclLightdropdownIcon from './../images/ncl-light/dropdown.svg'
import nclLightdownloadIcon from './../images/ncl-light/download.svg'
import nclLightfilterIcon from './../images/ncl-light/filter.svg'
import nclLightguestIcon from './../images/ncl-light/guest.svg'
import nclLighthamburgerIcon from './../images/ncl-light/hamburger.svg'
import nclLightmoreIcon from './../images/ncl-light/more.svg'
import nclLightpdfIcon from './../images/ncl-light/pdf.svg'
import nclLightprintIcon from './../images/ncl-light/print.svg'
import nclLightreportsIcon from './../images/ncl-light/reports.svg'
import nclLightsearchIcon from './../images/ncl-light/search.svg'
import nclLighttxtIcon from './../images/ncl-light/txt.svg'
import nclLightvisitorsIcon from './../images/ncl-light/visitors.svg'
import nclLightchevronIcon from './../images/ncl-light/chevron.svg'
import nclLightsortIcon from './../images/ncl-light/sort.svg'
import nclLightsortedIcon from './../images/ncl-light/sorted.svg'
import nclLighttickIcon from './../images/ncl-light/tick.svg'
import nclLighthandicapIcon from './../images/ncl-light/handicap.svg'
import nclLightcommonIcon from './../images/ncl-light/common.svg'
import nclLightopenFiltersIcon from './../images/ncl-light/open-filters.svg'
import nclLightAddIcon from './../images/ncl-light/add.svg'
import nclLightMinusIcon from './../images/ncl-light/minus.svg'
import nclLightInformationIcon from './../images/ncl-light/information.svg'
import nclLightrefreshIcon from './../images/ncl-light/refresh.svg'
import nclLightCabinIcon from './../images/ncl-light/cabin.svg'
import nclLightSettingsIcon from './../images/ncl-light/settings.svg'
import nclLightIpmIcon from './../images/ncl-light/ipm.svg'
import nclLightApprovedItemIcon from './../images/ncl-light/approved-item.svg'
import nclLightPendingItemIcon from './../images/vv-light/pending-item.svg'
import nclLightRejectedItemIcon from './../images/vv-light/rejected-item.svg'
import nclLightRemoveItemIcon from './../images/ncl-light/remove.svg'
import nclLighteditItemIcon from './../images/ncl-light/edit.svg'
import nclLightLoaderItemIcon from './../images/ncl-light/loader.svg'
import nclLighttransitionItemIcon from './../images/ncl-light/transition.svg'
import nclLightLoginBg from './../images/ncl-light/login_bg.png'
import nclLightNoShipBg from './../images/ncl-light/no-ship.jpg'
import nclLightBoardingSlot from './../images/ncl-light/boarding-slot.svg'
import nclLightArrowLeftIcon from './../images/ncl-light/arrow-left.svg'
import nclLightArrowRightIcon from './../images/ncl-light/arrow-right.svg'
import nclLightBirthdayIcon from './../images/ncl-light/birthday.svg'
import nclLightServiceDogIcon from './../images/ncl-light/service-dog.svg'
import nclLighttimeIcon from './../images/dxp-light/time.svg'
import nclLightPearlIcon from './../images/ncl-light/Pearl.svg'

import nclDarkMessageIcon from './../images/ncl-dark/message.svg'
import nclDarkconcerirgeIcon from './../images/ncl-dark/concerirge.svg'
import nclDarkcalendarIcon from './../images/ncl-dark/calendar.svg'
import nclDarkcrewIcon from './../images/ncl-dark/crew.svg'
import nclDarkdashboardIcon from './../images/ncl-dark/dashboard.svg'
import nclDarkdropdownIcon from './../images/ncl-dark/dropdown.svg'
import nclDarkdownloadIcon from './../images/ncl-dark/download.svg'
import nclDarkfilterIcon from './../images/ncl-dark/filter.svg'
import nclDarkguestIcon from './../images/ncl-dark/guest.svg'
import nclDarkhamburgerIcon from './../images/ncl-dark/hamburger.svg'
import nclDarkmoreIcon from './../images/ncl-dark/more.svg'
import nclDarkpdfIcon from './../images/ncl-dark/pdf.svg'
import nclDarkprintIcon from './../images/ncl-dark/print.svg'
import nclDarkreportsIcon from './../images/ncl-dark/reports.svg'
import nclDarksearchIcon from './../images/ncl-dark/search.svg'
import nclDarktxtIcon from './../images/ncl-dark/txt.svg'
import nclDarkvisitorsIcon from './../images/ncl-dark/visitors.svg'
import nclDarkchevronIcon from './../images/ncl-dark/chevron.svg'
import nclDarksortIcon from './../images/ncl-dark/sort.svg'
import nclDarksortedIcon from './../images/ncl-dark/sorted.svg'
import nclDarktickIcon from './../images/ncl-dark/tick.svg'
import nclDarkhandicapIcon from './../images/ncl-dark/handicap.svg'
import nclDarkcommonIcon from './../images/ncl-dark/common.svg'
import nclDarkopenFiltersIcon from './../images/ncl-dark/open-filters.svg'
import nclDarkAddIcon from './../images/ncl-dark/add.svg'
import nclDarkMinusIcon from './../images/ncl-dark/minus.svg'
import nclDarkInformationIcon from './../images/ncl-dark/information.svg'
import nclDarkrefreshIcon from './../images/ncl-dark/refresh.svg'
import nclDarkCabinIcon from './../images/ncl-dark/cabin.svg'
import nclDarkSettingsIcon from './../images/ncl-dark/settings.svg'
import nclDarkIpmIcon from './../images/ncl-dark/ipm.svg'
import nclDarkApprovedItemIcon from './../images/ncl-dark/approved-item.svg'
import nclDarkPendingItemIcon from './../images/ncl-dark/pending-item.svg'
import nclDarkRejectedItemIcon from './../images/ncl-dark/rejected-item.svg'
import nclDarkeditItemIcon from './../images/ncl-dark/edit.svg'
import nclDarkRemoveItemIcon from './../images/ncl-dark/remove.svg'
import nclDarkLoaderItemIcon from './../images/ncl-dark/loader.svg'
import nclDarktransitionItemIcon from './../images/ncl-dark/transition.svg'
import nclDarkLoginBg from './../images/ncl-dark/login_bg.png'
import nclDarkNoShipBg from './../images/ncl-dark/no-ship.jpg'
import nclDarkBoardingSlot from './../images/ncl-dark/boarding-slot.svg'
import nclDarkArrowLeftIcon from './../images/ncl-dark/arrow-left.svg'
import nclDarkArrowRightIcon from './../images/ncl-dark/arrow-right.svg'
import nclDarkBirthdayIcon from './../images/ncl-dark/birthday.svg'
import nclDarkServiceDogIcon from './../images/ncl-dark/service-dog.svg'
import nclDarktimeIcon from './../images/dxp-light/time.svg'
import nclDarkPearlIcon from './../images/ncl-dark/Pearl.svg'

import dclLightMessageIcon from './../images/dcl-light/message.svg'
import dclLightVipIcon from './../images/dcl-light/vip.png'
import dclLightconcerirgeIcon from './../images/dcl-light/concerirge.svg'
import dclLightdeleteIcon from './../images/dcl-light/delete.svg'
import dclLightcalendarIcon from './../images/dcl-light/calendar.svg'
import dclLightcrewIcon from './../images/dcl-light/crew.svg'
import dclLightdashboardIcon from './../images/dcl-light/dashboard.svg'
import dclLightdropdownIcon from './../images/dcl-light/dropdown.svg'
import dclLightdownloadIcon from './../images/dcl-light/download.svg'
import dclLightfilterIcon from './../images/dcl-light/filter.svg'
import dclLightguestIcon from './../images/dcl-light/guest.svg'
import dclLighthamburgerIcon from './../images/dcl-light/hamburger.svg'
import dclLightmoreIcon from './../images/dcl-light/more.svg'
import dclLightpdfIcon from './../images/dcl-light/pdf.svg'
import dclLightprintIcon from './../images/dcl-light/print.svg'
import dclLightreportsIcon from './../images/dcl-light/reports.svg'
import dclLightsearchIcon from './../images/dcl-light/search.svg'
import dclLighttxtIcon from './../images/dcl-light/txt.svg'
import dclLightvisitorsIcon from './../images/dcl-light/visitors.svg'
import dclLightchevronIcon from './../images/dcl-light/chevron.svg'
import dclLightsortIcon from './../images/dcl-light/sort.svg'
import dclLightsortedIcon from './../images/dcl-light/sorted.svg'
import dclLighttickIcon from './../images/dcl-light/tick.svg'
import dclLighthandicapIcon from './../images/dcl-light/handicap.svg'
import dclLightcommonIcon from './../images/dcl-light/common.svg'
import dclLightopenFiltersIcon from './../images/dcl-light/open-filters.svg'
import dclLightAddIcon from './../images/dcl-light/add.svg'
import dclLightMinusIcon from './../images/dcl-light/minus.svg'
import dclLightInformationIcon from './../images/dcl-light/information.svg'
import dclLightWarningIcon from './../images/dcl-light/warning.svg'
import dclLightrefreshIcon from './../images/dcl-light/refresh.svg'
import dclLightCabinIcon from './../images/dcl-light/cabin.svg'
import dclLightSettingsIcon from './../images/dcl-light/settings.svg'
import dclLightIpmIcon from './../images/dcl-light/ipm.svg'
import dclLightApprovedItemIcon from './../images/dcl-light/approved-item.svg'
import dclLightPendingItemIcon from './../images/dcl-light/pending-item.svg'
import dclLightRejectedItemIcon from './../images/dcl-light/rejected-item.svg'
import dclLightRemoveItemIcon from './../images/dcl-light/remove.svg'
import dclLighteditItemIcon from './../images/dcl-light/edit.svg'
import dclLightLoaderItemIcon from './../images/dcl-light/loader.gif'
import dclLighttransitionItemIcon from './../images/dcl-light/transition.svg'
import dclLightLoginBg from './../images/dcl-light/login_bg.jpg'
import dclLightNoShipBg from './../images/dcl-light/no-ship.jpg'
import dclLightBoardingSlot from './../images/dcl-light/boarding-slot.svg'
import dclLightArrowLeftIcon from './../images/dcl-light/arrow-left.svg'
import dclLightArrowRightIcon from './../images/dcl-light/arrow-right.svg'
import dclLightBirthdayIcon from './../images/dcl-light/birthday.svg'
import dclLightServiceDogIcon from './../images/dcl-light/service-dog.svg'
import dclLightStateroomIcon from './../images/dcl-light/stateroom.svg'
import dclLighttimeIcon from './../images/dxp-light/time.svg'
import dclLightGoldIcon from './../images/dcl-light/gold.svg'
import dclLightNewIcon from './../images/dcl-light/new.svg'
import dclLightPotentialIcon from './../images/dcl-light/potential.svg'
import dclLightPlatinumIcon from './../images/dcl-light/platinum.svg'
import dclLightSilverIcon from './../images/dcl-light/silver.svg'
import dclLightAlertRedIcon from './../images/dcl-light/alert-red.svg'
import dclLightPrimaryGuestIcon from './../images/dcl-light/primary-guest.svg'
import dclLightInfoAlertIcon from './../images/dcl-light/info-alert.svg'
import dclLightPearlIcon from './../images/dcl-light/Pearl.svg'

import dclDarkMessageIcon from './../images/dcl-dark/message.svg'
import dclDarkconcerirgeIcon from './../images/dcl-dark/concerirge.svg'
import dclDarkdeleteIcon from './../images/dcl-dark/delete.svg'
import dclDarkcalendarIcon from './../images/dcl-dark/calendar.svg'
import dclDarkcrewIcon from './../images/dcl-dark/crew.svg'
import dclDarkdashboardIcon from './../images/dcl-dark/dashboard.svg'
import dclDarkdropdownIcon from './../images/dcl-dark/dropdown.svg'
import dclDarkdownloadIcon from './../images/dcl-dark/download.svg'
import dclDarkfilterIcon from './../images/dcl-dark/filter.svg'
import dclDarkguestIcon from './../images/dcl-dark/guest.svg'
import dclDarkhamburgerIcon from './../images/dcl-dark/hamburger.svg'
import dclDarkmoreIcon from './../images/dcl-dark/more.svg'
import dclDarkpdfIcon from './../images/dcl-dark/pdf.svg'
import dclDarkprintIcon from './../images/dcl-dark/print.svg'
import dclDarkreportsIcon from './../images/dcl-dark/reports.svg'
import dclDarksearchIcon from './../images/dcl-dark/search.svg'
import dclDarktxtIcon from './../images/dcl-dark/txt.svg'
import dclDarkvisitorsIcon from './../images/dcl-dark/visitors.svg'
import dclDarkchevronIcon from './../images/dcl-dark/chevron.svg'
import dclDarksortIcon from './../images/dcl-dark/sort.svg'
import dclDarksortedIcon from './../images/dcl-dark/sorted.svg'
import dclDarktickIcon from './../images/dcl-dark/tick.svg'
import dclDarkhandicapIcon from './../images/dcl-dark/handicap.svg'
import dclDarkcommonIcon from './../images/dcl-dark/common.svg'
import dclDarkopenFiltersIcon from './../images/dcl-dark/open-filters.svg'
import dclDarkAddIcon from './../images/dcl-dark/add.svg'
import dclDarkMinusIcon from './../images/dcl-dark/minus.svg'
import dclDarkInformationIcon from './../images/dcl-dark/information.svg'
import dclDarkWarningIcon from './../images/dcl-dark/warning.svg'
import dclDarkrefreshIcon from './../images/dcl-dark/refresh.svg'
import dclDarkCabinIcon from './../images/dcl-dark/cabin.svg'
import dclDarkSettingsIcon from './../images/dcl-dark/settings.svg'
import dclDarkIpmIcon from './../images/dcl-dark/ipm.svg'
import dclDarkApprovedItemIcon from './../images/dcl-dark/approved-item.svg'
import dclDarkPendingItemIcon from './../images/dcl-dark/pending-item.svg'
import dclDarkRejectedItemIcon from './../images/dcl-dark/rejected-item.svg'
import dclDarkRemoveItemIcon from './../images/dcl-dark/remove.svg'
import dclDarkeditItemIcon from './../images/dcl-dark/edit.svg'
import dclDarkLoaderItemIcon from './../images/dcl-dark/loader.gif'
import dclDarktransitionItemIcon from './../images/dcl-dark/transition.svg'
import dclDarkLoginBg from './../images/dcl-dark/login_bg.jpg'
import dclDarkNoShipBg from './../images/dcl-dark/no-ship.jpg'
import dclDarkBoardingSlot from './../images/dcl-light/boarding-slot.svg'
import dclDarkArrowLeftIcon from './../images/dcl-dark/arrow-left.svg'
import dclDarkArrowRightIcon from './../images/dcl-dark/arrow-right.svg'
import dclDarkBirthdayIcon from './../images/dcl-dark/birthday.svg'
import dclDarkServiceDogIcon from './../images/dcl-dark/service-dog.svg'
import dclDarkStateroomIcon from './../images/dcl-dark/stateroom.svg'
import dclDarkGoldIcon from './../images/dcl-dark/gold.svg'
import dclDarkNewIcon from './../images/dcl-dark/new.svg'
import dclDarkPotentialIcon from './../images/dcl-dark/potential.svg'
import dclDarkPlatinumIcon from './../images/dcl-dark/platinum.svg'
import dclDarkSilverIcon from './../images/dcl-dark/silver.svg'
import dclDarktimeIcon from './../images/dxp-light/time.svg'
import dclDarkVipIcon from './../images/dcl-dark/vip.png'
import dclDarkAlertRedIcon from './../images/dcl-dark/alert-red.svg'
import dclDarkPrimaryGuestIcon from './../images/dcl-dark/primary-guest.svg'
import dclDarkInfoAlertIcon from './../images/dcl-dark/info-alert.svg'
import dclDarkPearlIcon from './../images/dcl-dark/Pearl.svg'
import { cloneDeep, isEmpty, isString, omitBy, sortBy } from 'lodash'
//import { AuthenticationHandler } from '../containers/dxp-auth-handler-local'
import { AuthenticationHandler } from 'dxp-auth-handler'
import { removeMetaData, setMetaData } from 'dxp-ui-logger'

const icons = {}

icons['dxp-light'] = {
  message: dxpLightMessageIcon,
  concerirge: dxpLightconcerirgeIcon,
  calendar: dxpLightcalendarIcon,
  crew: dxpLightcrewIcon,
  delete: dxpLightdeleteIcon,
  dashboard: dxpLightdashboardIcon,
  dropdown: dxpLightdropdownIcon,
  download: dxpLightdownloadIcon,
  filter: dxpLightfilterIcon,
  guest: dxpLightguestIcon,
  hamburger: dxpLighthamburgerIcon,
  more: dxpLightmoreIcon,
  pdf: dxpLightpdfIcon,
  print: dxpLightprintIcon,
  reports: dxpLightreportsIcon,
  search: dxpLightsearchIcon,
  txt: dxpLighttxtIcon,
  visitors: dxpLightvisitorsIcon,
  chevron: dxpLightchevronIcon,
  sort: dxpLightsortIcon,
  sorted: dxpLightsortedIcon,
  tick: dxpLighttickIcon,
  handicap: dxpLighthandicapIcon,
  common: dxpLightcommonIcon,
  openFilters: dxpLightopenFiltersIcon,
  add: dxpLightAddIcon,
  minus: dxpLightMinusIcon,
  information: dxpLightInformationIcon,
  warning: dxpLightWarningIcon,
  refresh: dxpLightrefreshIcon,
  cabin: dxpLightCabinIcon,
  settings: dxpLightSettingsIcon,
  ipm: dxpLightIpmIcon,
  approvedItem: dxpLightApprovedItemIcon,
  pendingItem: dxpLightPendingItemIcon,
  rejectedItem: dxpLightRejectedItemIcon,
  remove: dxpLightRemoveItemIcon,
  edit: dxpLighteditItemIcon,
  loader: dxpLightLoaderItemIcon,
  transition: dxpLighttransitionItemIcon,
  loginBg: dxpLightLoginBg,
  shipBg: dxpLightNoShipBg,
  boardingSlot: dxpLightBoardingSlot,
  arrowLeft: dxpLightArrowLeftIcon,
  arrowRight: dxpLightArrowRightIcon,
  birthday: dxpLightBirthdayIcon,
  serviceDog: dxpLightServiceDogIcon,
  new: dxpLightNewIcon,
  potential: dxpLightPotentialIcon,
  platinum: dxpLightPlatinumIcon,
  gold: dxpLightGoldIcon,
  silver: dxpLightSilverIcon,
  time: dxpLighttimeIcon,
  stateroom: dxpLightStateroomIcon,
  alert_red: dxpLightAlertRedIcon,
  primary_guest: dxpLightPrimaryGuestIcon,
  info_alert: dxpLightInfoAlertIcon,
  masterBoarding: dxpLightMasterBoardingIcon,
  pearl: dxpLightPearlIcon
}

icons['dxp-dark'] = {
  message: dxpDarkMessageIcon,
  concerirge: dxpDarkconcerirgeIcon,
  delete: dxpDarkdeleteIcon,
  calendar: dxpDarkcalendarIcon,
  crew: dxpDarkcrewIcon,
  dashboard: dxpDarkdashboardIcon,
  dropdown: dxpDarkdropdownIcon,
  download: dxpDarkdownloadIcon,
  filter: dxpDarkfilterIcon,
  guest: dxpDarkguestIcon,
  hamburger: dxpDarkhamburgerIcon,
  more: dxpDarkmoreIcon,
  pdf: dxpDarkpdfIcon,
  print: dxpDarkprintIcon,
  reports: dxpDarkreportsIcon,
  search: dxpDarksearchIcon,
  txt: dxpDarktxtIcon,
  visitors: dxpDarkvisitorsIcon,
  chevron: dxpDarkchevronIcon,
  sort: dxpDarksortIcon,
  sorted: dxpDarksortedIcon,
  tick: dxpDarktickIcon,
  handicap: dxpDarkhandicapIcon,
  common: dxpDarkcommonIcon,
  openFilters: dxpDarkopenFiltersIcon,
  add: dxpDarkAddIcon,
  minus: dxpDarkMinusIcon,
  information: dxpDarkInformationIcon,
  warning: dxpDarkWarningIcon,
  refresh: dxpDarkrefreshIcon,
  cabin: dxpDarkCabinIcon,
  settings: dxpDarkSettingsIcon,
  ipm: dxpDarkIpmIcon,
  approvedItem: dxpDarkApprovedItemIcon,
  pendingItem: dxpDarkPendingItemIcon,
  rejectedItem: dxpDarkRejectedItemIcon,
  remove: dxpDarkRemoveItemIcon,
  edit: dxpDarkeditItemIcon,
  loader: dxpDarkLoaderItemIcon,
  transition: dxpDarktransitionItemIcon,
  loginBg: dxpDarkLoginBg,
  shipBg: dxpDarkNoShipBg,
  boardingSlot: dxpDarkBoardingSlot,
  arrowLeft: dxpDarkArrowLeftIcon,
  arrowRight: dxpDarkArrowRightIcon,
  birthday: dxpDarkBirthdayIcon,
  serviceDog: dxpDarkServiceDogIcon,
  new: dxpDarkNewIcon,
  potential: dxpDarkPotentialIcon,
  platinum: dxpDarkPlatinumIcon,
  gold: dxpDarkGoldIcon,
  silver: dxpDarkSilverIcon,
  time: dxpDarktimeIcon,
  stateroom: dxpDarkStateroomIcon,
  alert_red: dxpDarkAlertRedIcon,
  primary_guest: dxpDarkPrimaryGuestIcon,
  info_alert: dxpDarkInfoAlertIcon,
  masterBoarding: dxpDarkMasterBoardingIcon,
  pearl: dxpDarkPearlIcon
}

icons['vv-light'] = {
  message: vvLightMessageIcon,
  concerirge: vvLightconcerirgeIcon,
  calendar: vvLightcalendarIcon,
  crew: vvLightcrewIcon,
  delete: vvLightDeleteIcon,
  dashboard: vvLightdashboardIcon,
  dropdown: vvLightdropdownIcon,
  download: vvLightdownloadIcon,
  filter: vvLightfilterIcon,
  guest: vvLightguestIcon,
  hamburger: vvLighthamburgerIcon,
  more: vvLightmoreIcon,
  pdf: vvLightpdfIcon,
  print: vvLightprintIcon,
  reports: vvLightreportsIcon,
  search: vvLightsearchIcon,
  txt: vvLighttxtIcon,
  visitors: vvLightvisitorsIcon,
  chevron: vvLightchevronIcon,
  sort: vvLightsortIcon,
  sorted: vvLightsortedIcon,
  tick: vvLighttickIcon,
  circletick: vvLightCircletickIcon,
  warning: vvLightWarningIcon,
  coordinate: vvLightCoordinateIcon,
  handicap: vvLighthandicapIcon,
  common: vvLightcommonIcon,
  openFilters: vvLightopenFiltersIcon,
  add: vvLightAddIcon,
  minus: vvLightMinusIcon,
  information: vvLightInformationIcon,
  refresh: vvLightrefreshIcon,
  cabin: vvLightCabinIcon,
  settings: vvLightSettingsIcon,
  ipm: vvLightIpmIcon,
  approvedItem: vvLightApprovedItemIcon,
  pendingItem: vvLightPendingItemIcon,
  rejectedItem: vvLightRejectedItemIcon,
  remove: vvLightRemoveItemIcon,
  edit: vvLighteditItemIcon,
  loader: vvLightLoaderItemIcon,
  transition: vvLighttransitionItemIcon,
  loginBg: vvLightLoginBg,
  shipBg: vvLightNoShipBg,
  boardingSlot: vvLightBoardingSlot,
  arrowLeft: vvLightArrowLeftIcon,
  arrowRight: vvLightArrowRightIcon,
  birthday: vvLightBirthdayIcon,
  serviceDog: vvLightServiceDogIcon,
  time: vvLighttimeIcon,
  masterBoarding: vvLightMasterBoardingIcon,
  pearl: vvLightPearlIcon,
  motorizedScooter: vvLightMotorizedScooterIcon,
  slotFlag: vvLightSlotFlagIcon,
  alert_red: vvLightAlertRedIcon
}

icons['vv-dark'] = {
  message: vvDarkMessageIcon,
  concerirge: vvDarkconcerirgeIcon,
  calendar: vvDarkcalendarIcon,
  crew: vvDarkcrewIcon,
  dashboard: vvDarkdashboardIcon,
  delete: vvDarkDeleteIcon,
  dropdown: vvDarkdropdownIcon,
  download: vvDarkdownloadIcon,
  filter: vvDarkfilterIcon,
  guest: vvDarkguestIcon,
  hamburger: vvDarkhamburgerIcon,
  more: vvDarkmoreIcon,
  pdf: vvDarkpdfIcon,
  print: vvDarkprintIcon,
  reports: vvDarkreportsIcon,
  search: vvDarksearchIcon,
  txt: vvDarktxtIcon,
  visitors: vvDarkvisitorsIcon,
  chevron: vvDarkchevronIcon,
  sort: vvDarksortIcon,
  sorted: vvDarksortedIcon,
  tick: vvDarktickIcon,
  circletick: vvDarkCircletickIcon,
  warning: vvDarkWarningIcon,
  coordinate: vvDarkCoordinateIcon,
  handicap: vvDarkhandicapIcon,
  common: vvDarkcommonIcon,
  openFilters: vvDarkopenFiltersIcon,
  add: vvDarkAddIcon,
  minus: vvDarkMinusIcon,
  information: vvDarkInformationIcon,
  refresh: vvDarkrefreshIcon,
  cabin: vvDarkCabinIcon,
  settings: vvDarkSettingsIcon,
  ipm: vvDarkIpmIcon,
  approvedItem: vvDarkApprovedItemIcon,
  pendingItem: vvDarkPendingItemIcon,
  rejectedItem: vvDarkRejectedItemIcon,
  remove: vvDarkRemoveItemIcon,
  edit: vvDarkeditItemIcon,
  loader: vvDarkLoaderItemIcon,
  transition: vvDarktransitionItemIcon,
  loginBg: vvDarkLoginBg,
  shipBg: vvDarkNoShipBg,
  boardingSlot: vvDarkBoardingSlot,
  arrowLeft: vvDarkArrowLeftIcon,
  arrowRight: vvDarkArrowRightIcon,
  birthday: vvDarkBirthdayIcon,
  serviceDog: vvDarkServiceDogIcon,
  time: vvDarktimeIcon,
  masterBoarding: vvDarkMasterBoardingIcon,
  pearl: vvDarkPearlIcon,
  alert_red: vvDarkAlertRedIcon
}

icons['ncl-light'] = {
  message: nclLightMessageIcon,
  concerirge: nclLightconcerirgeIcon,
  calendar: nclLightcalendarIcon,
  crew: nclLightcrewIcon,
  dashboard: nclLightdashboardIcon,
  dropdown: nclLightdropdownIcon,
  download: nclLightdownloadIcon,
  filter: nclLightfilterIcon,
  guest: nclLightguestIcon,
  hamburger: nclLighthamburgerIcon,
  more: nclLightmoreIcon,
  pdf: nclLightpdfIcon,
  print: nclLightprintIcon,
  reports: nclLightreportsIcon,
  search: nclLightsearchIcon,
  txt: nclLighttxtIcon,
  visitors: nclLightvisitorsIcon,
  chevron: nclLightchevronIcon,
  sort: nclLightsortIcon,
  sorted: nclLightsortedIcon,
  tick: nclLighttickIcon,
  handicap: nclLighthandicapIcon,
  common: nclLightcommonIcon,
  openFilters: nclLightopenFiltersIcon,
  add: nclLightAddIcon,
  minus: nclLightMinusIcon,
  information: nclLightInformationIcon,
  refresh: nclLightrefreshIcon,
  cabin: nclLightCabinIcon,
  settings: nclLightSettingsIcon,
  ipm: nclLightIpmIcon,
  approvedItem: nclLightApprovedItemIcon,
  pendingItem: nclLightPendingItemIcon,
  rejectedItem: nclLightRejectedItemIcon,
  remove: nclLightRemoveItemIcon,
  edit: nclLighteditItemIcon,
  loader: nclLightLoaderItemIcon,
  transition: nclLighttransitionItemIcon,
  loginBg: nclLightLoginBg,
  shipBg: nclLightNoShipBg,
  boardingSlot: nclLightBoardingSlot,
  arrowLeft: nclLightArrowLeftIcon,
  arrowRight: nclLightArrowRightIcon,
  birthday: nclLightBirthdayIcon,
  serviceDog: nclLightServiceDogIcon,
  time: nclLighttimeIcon,
  pearl: nclLightPearlIcon
}

icons['ncl-dark'] = {
  message: nclDarkMessageIcon,
  concerirge: nclDarkconcerirgeIcon,
  calendar: nclDarkcalendarIcon,
  crew: nclDarkcrewIcon,
  dashboard: nclDarkdashboardIcon,
  dropdown: nclDarkdropdownIcon,
  download: nclDarkdownloadIcon,
  filter: nclDarkfilterIcon,
  guest: nclDarkguestIcon,
  hamburger: nclDarkhamburgerIcon,
  more: nclDarkmoreIcon,
  pdf: nclDarkpdfIcon,
  print: nclDarkprintIcon,
  reports: nclDarkreportsIcon,
  search: nclDarksearchIcon,
  txt: nclDarktxtIcon,
  visitors: nclDarkvisitorsIcon,
  chevron: nclDarkchevronIcon,
  sort: nclDarksortIcon,
  sorted: nclDarksortedIcon,
  tick: nclDarktickIcon,
  handicap: nclDarkhandicapIcon,
  common: nclDarkcommonIcon,
  openFilters: nclDarkopenFiltersIcon,
  add: nclDarkAddIcon,
  minus: nclDarkMinusIcon,
  information: nclDarkInformationIcon,
  refresh: nclDarkrefreshIcon,
  cabin: nclDarkCabinIcon,
  settings: nclDarkSettingsIcon,
  ipm: nclDarkIpmIcon,
  approvedItem: nclDarkApprovedItemIcon,
  pendingItem: nclDarkPendingItemIcon,
  rejectedItem: nclDarkRejectedItemIcon,
  remove: nclDarkRemoveItemIcon,
  edit: nclDarkeditItemIcon,
  loader: nclDarkLoaderItemIcon,
  transition: nclDarktransitionItemIcon,
  loginBg: nclDarkLoginBg,
  shipBg: nclDarkNoShipBg,
  boardingSlot: nclDarkBoardingSlot,
  arrowLeft: nclDarkArrowLeftIcon,
  arrowRight: nclDarkArrowRightIcon,
  birthday: nclDarkBirthdayIcon,
  serviceDog: nclDarkServiceDogIcon,
  time: nclDarktimeIcon,
  pearl: nclDarkPearlIcon
}

icons['dcl-light'] = {
  message: dclLightMessageIcon,
  concerirge: dclLightconcerirgeIcon,
  delete: dclLightdeleteIcon,
  vip: dclLightVipIcon,
  calendar: dclLightcalendarIcon,
  crew: dclLightcrewIcon,
  dashboard: dclLightdashboardIcon,
  dropdown: dclLightdropdownIcon,
  download: dclLightdownloadIcon,
  filter: dclLightfilterIcon,
  guest: dclLightguestIcon,
  hamburger: dclLighthamburgerIcon,
  more: dclLightmoreIcon,
  pdf: dclLightpdfIcon,
  print: dclLightprintIcon,
  reports: dclLightreportsIcon,
  search: dclLightsearchIcon,
  txt: dclLighttxtIcon,
  visitors: dclLightvisitorsIcon,
  chevron: dclLightchevronIcon,
  sort: dclLightsortIcon,
  sorted: dclLightsortedIcon,
  tick: dclLighttickIcon,
  handicap: dclLighthandicapIcon,
  common: dclLightcommonIcon,
  openFilters: dclLightopenFiltersIcon,
  add: dclLightAddIcon,
  minus: dclLightMinusIcon,
  information: dclLightInformationIcon,
  warning: dclLightWarningIcon,
  refresh: dclLightrefreshIcon,
  cabin: dclLightCabinIcon,
  settings: dclLightSettingsIcon,
  ipm: dclLightIpmIcon,
  approvedItem: dclLightApprovedItemIcon,
  pendingItem: dclLightPendingItemIcon,
  rejectedItem: dclLightRejectedItemIcon,
  remove: dclLightRemoveItemIcon,
  edit: dclLighteditItemIcon,
  loader: dclLightLoaderItemIcon,
  transition: dclLighttransitionItemIcon,
  loginBg: dclLightLoginBg,
  shipBg: dclLightNoShipBg,
  boardingSlot: dclLightBoardingSlot,
  arrowLeft: dclLightArrowLeftIcon,
  arrowRight: dclLightArrowRightIcon,
  birthday: dclLightBirthdayIcon,
  serviceDog: dclLightServiceDogIcon,
  new: dclLightNewIcon,
  potential: dclLightPotentialIcon,
  platinum: dclLightPlatinumIcon,
  gold: dclLightGoldIcon,
  silver: dclLightSilverIcon,
  time: dclLighttimeIcon,
  stateroom: dclLightStateroomIcon,
  alert_red: dclLightAlertRedIcon,
  primary_guest: dclLightPrimaryGuestIcon,
  info_alert: dclLightInfoAlertIcon,
  pearl: dclLightPearlIcon
}

icons['dcl-dark'] = {
  message: dclDarkMessageIcon,
  concerirge: dclDarkconcerirgeIcon,
  delete: dclDarkdeleteIcon,
  calendar: dclDarkcalendarIcon,
  crew: dclDarkcrewIcon,
  vip: dclDarkVipIcon,
  dashboard: dclDarkdashboardIcon,
  dropdown: dclDarkdropdownIcon,
  download: dclDarkdownloadIcon,
  filter: dclDarkfilterIcon,
  guest: dclDarkguestIcon,
  hamburger: dclDarkhamburgerIcon,
  more: dclDarkmoreIcon,
  pdf: dclDarkpdfIcon,
  print: dclDarkprintIcon,
  reports: dclDarkreportsIcon,
  search: dclDarksearchIcon,
  txt: dclDarktxtIcon,
  visitors: dclDarkvisitorsIcon,
  chevron: dclDarkchevronIcon,
  sort: dclDarksortIcon,
  sorted: dclDarksortedIcon,
  tick: dclDarktickIcon,
  handicap: dclDarkhandicapIcon,
  common: dclDarkcommonIcon,
  openFilters: dclDarkopenFiltersIcon,
  add: dclDarkAddIcon,
  minus: dclDarkMinusIcon,
  information: dclDarkInformationIcon,
  warning: dclDarkWarningIcon,
  refresh: dclDarkrefreshIcon,
  cabin: dclDarkCabinIcon,
  settings: dclDarkSettingsIcon,
  ipm: dclDarkIpmIcon,
  approvedItem: dclDarkApprovedItemIcon,
  pendingItem: dclDarkPendingItemIcon,
  rejectedItem: dclDarkRejectedItemIcon,
  remove: dclDarkRemoveItemIcon,
  edit: dclDarkeditItemIcon,
  loader: dclDarkLoaderItemIcon,
  transition: dclDarktransitionItemIcon,
  loginBg: dclDarkLoginBg,
  shipBg: dclDarkNoShipBg,
  boardingSlot: dclDarkBoardingSlot,
  arrowLeft: dclDarkArrowLeftIcon,
  arrowRight: dclDarkArrowRightIcon,
  birthday: dclDarkBirthdayIcon,
  serviceDog: dclDarkServiceDogIcon,
  time: dclDarktimeIcon,
  new: dclDarkNewIcon,
  potential: dclDarkPotentialIcon,
  platinum: dclDarkPlatinumIcon,
  gold: dclDarkGoldIcon,
  silver: dclDarkSilverIcon,
  stateroom: dclDarkStateroomIcon,
  alert_red: dclDarkAlertRedIcon,
  primary_guest: dclDarkPrimaryGuestIcon,
  info_alert: dclDarkInfoAlertIcon,
  pearl: dclDarkPearlIcon
}

export const getMobileOperatingSystem = () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'IOS'

  if (/android/i.test(userAgent)) return 'android'

  return null
}

export const isDescendant = (parent, child) => {
  if (!parent || !child) {
    return false
  }

  var node = child.parentNode
  while (node != null) {
    if (node === parent) {
      return true
    }
    node = node.parentNode
  }
  return false
}

export const getSVG = svg => {
  const theme =
    document.getElementsByTagName('body')[0].classList[0] || 'dxp-light'
  return icons[theme][svg]
}

export const getShipTime = shipTimes => {
  // const utcDate = get(shipTimes, 'fromUtcDate', '')
  const utcDate = getUtcDate()
  const offset = get(shipTimes, 'fromDateOffset', '')
  return addOffset(utcDate, offset)
}

export const getimportShipTimeByUtcDate = (shipTimes, utcDate) => {
  const offset = get(shipTimes, 'fromDateOffset', '')
  return addOffset(utcDate, offset)
}

export const validateFile = (oForm, _validFileExtensions) => {
  var arrInputs = oForm.getElementsByTagName('input')
  for (var i = 0; i < arrInputs.length; i++) {
    var oInput = arrInputs[i]
    if (oInput.type == 'file') {
      var sFileName = oInput.value
      if (sFileName.length > 0) {
        var blnValid = false
        for (var j = 0; j < _validFileExtensions.length; j++) {
          var sCurExtension = _validFileExtensions[j]
          if (
            sFileName
              .substr(
                sFileName.length - sCurExtension.length,
                sCurExtension.length
              )
              .toLowerCase() == sCurExtension.toLowerCase()
          ) {
            blnValid = true
            break
          }
        }

        if (!blnValid) {
          return false
        }
      }
    }
  }

  return true
}

export function getParameterByName(name, url) {
  if (!url) url = window.location.href
  name = name.replace('[[]]/g', '\\$&')
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export function getFullName(firstName, lastName) {
  let fullName = `${firstName || ''} ${lastName || ''}`
  return fullName.trim() || '-'
}

const SYSTEM_CREATED_BY = 'System'
const SYSTEM_CREATED_BY_PATTERN = /^(system|system\s*\(auto alert\))$/i
const CREATED_BY_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const createdByLabel = value => {
  if (value && typeof value === 'object') {
    const name = getFullName(
      get(value, 'personalInfo.firstName'),
      get(value, 'personalInfo.lastName')
    )
    return name === '-' ? '' : name
  }
  const text = (value || '').trim()
  if (!text || CREATED_BY_ID_PATTERN.test(text)) {
    return ''
  }
  return text
}

export function getAlertCreatedByDisplay(alert) {
  const raw =
    createdByLabel(get(alert, 'alertCreatedBy')) ||
    createdByLabel(get(alert, 'alertCreatedByPersonId')) ||
    createdByLabel(get(alert, 'fromPerson')) ||
    ''
  if (!raw || SYSTEM_CREATED_BY_PATTERN.test(raw)) {
    return SYSTEM_CREATED_BY
  }
  return raw
}

export function getNameAndDesignation(userDetails) {
  let submittedByName = get(userDetails, 'firstName', '')
  submittedByName += userDetails.lastName ? ` ${userDetails.lastName}` : ''
  submittedByName += userDetails.designation
    ? ` - ${userDetails.designation}`
    : ''
  return submittedByName
}

export const sortBasedOnString = (stringA, stringB) => {
  const labelA = stringA.toLowerCase()
  const labelB = stringB.toLowerCase()
  if (labelA < labelB) {
    return -1
  } else if (labelA > labelB) {
    return 1
  } else {
    return 0
  }
}

export const checkIfSlotIsVipOrPriority = (
  boardingGroup,
  intl,
  is12hoursFormat = false,
  vipBoardingNumber = VIP_BOARDING_NUMBER,
  priorityBoardingNumber = PRIORITY_BOARDING_NUMBER,
  isDisplayTimeWithVipAndPriority = true
) => {
  let boardingSlotLabel = ''
  if (is12hoursFormat) {
    boardingSlotLabel = `${convertIn12HoursFormat(
      boardingGroup.boardingSlotStartTime
    ) || ''}-${convertIn12HoursFormat(boardingGroup.boardingSlotEndTime) || ''}`
  }
  {
    boardingSlotLabel = `${(
      boardingGroup.boardingSlotStartTime || ''
    ).substring(0, 5)}-${(boardingGroup.boardingSlotEndTime || '').substring(
      0,
      5
    )}`
  }
  if (boardingGroup.boardingNumber === vipBoardingNumber) {
    return `${intl.formatMessage({
      id: 'ChangeBoardingSlotModal.boardAnytime',
      defaultMessage: 'VIP Boarding'
    })} ${isDisplayTimeWithVipAndPriority ? `(${boardingSlotLabel})` : ''}`
  } else if (boardingGroup.boardingNumber === priorityBoardingNumber) {
    return `${intl.formatMessage({
      id: 'ChangeBoardingSlotModal.priorityBoarding',
      defaultMessage: 'Priority Boarding'
    })} ${isDisplayTimeWithVipAndPriority ? `(${boardingSlotLabel})` : ''}`
  } else {
    return boardingSlotLabel
  }
}

export const getIsClearedStatus = (isCleared, intl) => {
  if (isCleared === true) {
    return intl.formatMessage({
      id: 'Reports.cleared',
      defaultMessage: 'Cleared'
    })
  } else if (isCleared === false) {
    return intl.formatMessage({
      id: 'Reports.notCleared',
      defaultMessage: 'Not Cleared'
    })
  } else {
    return intl.formatMessage({
      id: 'Reports.deleted',
      defaultMessage: 'Deleted'
    })
  }
}

export const getAlertMessageValidity = (shipTime, startDate, endDate, intl) => {
  if (isDateBetween(shipTime, startDate, endDate)) {
    return intl.formatMessage({
      id: 'Reports.active',
      defaultMessage: 'Active'
    })
  } else if (isBefore(shipTime, startDate)) {
    return intl.formatMessage({
      id: 'Reports.inActive',
      defaultMessage: 'In-Active'
    })
  } else {
    return intl.formatMessage({
      id: 'Reports.expired',
      defaultMessage: 'Expired'
    })
  }
}
export const getAlertMessageStatus = (personAlerts, alertMessagetype, intl) => {
  if (alertMessagetype == 'alert') {
    return get(personAlerts, [0, 'isCleared'], false)
      ? intl.formatMessage({
          id: 'Reports.StatusCleared',
          defaultMessage: 'Cleared'
        })
      : intl.formatMessage({
          id: 'Reports.StatusNotCleared',
          defaultMessage: 'Not Cleared'
        })
  } else {
    if (get(personAlerts, [0, 'isCleared'], false)) {
      return intl.formatMessage({
        id: 'Reports.StatusCleared',
        defaultMessage: 'Cleared'
      })
    } else if (get(personAlerts, [0, 'isRead'], false)) {
      return intl.formatMessage({
        id: 'Reports.StatusaAknowledged',
        defaultMessage: 'Acknowledged'
      })
    } else {
      return intl.formatMessage({
        id: 'Reports.StatusNotCleared',
        defaultMessage: 'Not Cleared'
      })
    }
  }
}
export const getSubString = (str, start = 0, end = 20) => {
  let newStr = ''
  if (str) {
    if (str.length > 0) {
      newStr = str.substring(start, end)
      return (newStr = str.length > end ? newStr + '....' : newStr)
    } else {
      return newStr
    }
  }
}
export const mapTokenInfo = tokenData => {
  return {
    accessToken: tokenData.access_token,
    tokenType: tokenData.token_type,
    refreshToken: tokenData.refresh_token,
    expiresIn: tokenData.expires_in,
    scope: tokenData.scope,
    companyid: tokenData.companyid,
    appid: tokenData.appid,
    usertype: tokenData.usertype,
    deviceid: tokenData.deviceid,
    userid: tokenData.userGUID || tokenData.userid,
    jti: tokenData.jti
  }
}

export const mapAuthData = ({ auth, user }) => {
  if (!isEmpty(auth)) {
    const parsedData = { ...JSON.parse(auth), ...JSON.parse(user) }
    const authData = {}
    authData['tokenDetail'] = mapTokenInfo(parsedData.tokenData)
    const userData = get(parsedData, 'userProfile', {})
    authData['userProfileDetail'] = {
      crewId: get(parsedData, 'tokenData.userGUID', ''),
      firstName: get(userData, 'firstName', ''),
      lastName: get(userData, 'lastName', ''),
      gender: get(userData, 'gender', ''),
      designation: get(userData, 'designation', ''),
      userName: get(userData, 'userName', '')
    }
    return authData
  }
  return auth
}
export const getAllSelectionCleared = (type, filterList) => {
  if (type in filterList) {
    delete filterList[type]
  }
  return filterList
}

const CRUISE_CONTRACT_ACI_APPLICATION_ID = '4b805361-ff06-425b-81e3-cf66a6edfd6f'
const CRUISE_CONTRACT_RTS_APPLICATION_ID = 'ad9cca5e-3ef3-4d5f-938c-761c737a8d03'

export const getCruiseContractApplicationIds = settings => {
  const normalize = value => (typeof value === 'string' ? value.trim() : '')
  const applicationOptions = get(
    settings,
    'crewRolesManagement.applicationOptions.options',
    []
  )
  const getApplicationId = label => {
    if (!Array.isArray(applicationOptions)) return ''
    const application = applicationOptions.find(
      option => normalize(option && option.label).toUpperCase() === label
    )
    return normalize(application && application.value)
  }
  const configuredAciId = getApplicationId('ACI') || CRUISE_CONTRACT_ACI_APPLICATION_ID
  const configuredRtsId = getApplicationId('RTS') || CRUISE_CONTRACT_RTS_APPLICATION_ID
  const hasAmbiguousIds = Boolean(
    configuredAciId &&
    configuredRtsId &&
    configuredAciId === configuredRtsId
  )
  return {
    aciId: configuredAciId,
    rtsId: configuredRtsId,
    hasValidAciId: Boolean(configuredAciId) && !hasAmbiguousIds,
    hasValidRtsId: Boolean(configuredRtsId) && !hasAmbiguousIds
  }
}

export const formatCruiseContractStatus = (
  isCruiseContractSigned,
  cruiseContractCompletedBy,
  aciApplicationId,
  rtsApplicationId
) => {
  const completion = isCruiseContractSigned === true
    ? cruiseContractStatusLabels.completed
    : cruiseContractStatusLabels.notCompleted
  const applicationId = typeof cruiseContractCompletedBy === 'string'
    ? cruiseContractCompletedBy.trim()
    : cruiseContractCompletedBy
  const aciId = typeof aciApplicationId === 'string' ? aciApplicationId.trim() : aciApplicationId
  const rtsId = typeof rtsApplicationId === 'string' ? rtsApplicationId.trim() : rtsApplicationId

  if (!applicationId) {
    return isCruiseContractSigned === true
      ? `${completion} - ${cruiseContractStatusLabels.notApplicable}`
      : completion
  }
  const hasAmbiguousIds = Boolean(aciId && rtsId && aciId === rtsId)
  if (!hasAmbiguousIds && aciId && applicationId === aciId) return `${completion} - ACI`
  if (!hasAmbiguousIds && rtsId && applicationId === rtsId) return `${completion} - RTS`
  return `${completion} - ${cruiseContractStatusLabels.otherApplication}`
}

export const getCookieValue = cookieName => {
  const arr = document.cookie.split(';')
  let val = ''
  arr.forEach(each => {
    const splitted = each.trim().split('=')
    if (splitted[0] === cookieName) {
      val = splitted[1]
    }
  })
  return val
}

export const clearCookie = name => {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
}

export const getFilterTableColumns = (tableColumns, intl) => {
  return tableColumns.map(column => {
    column['Header'] = get(column, ['Header', 'id'], false)
      ? intl.formatMessage({
          id: get(column, ['Header', 'id'], ''),
          defaultMessage: get(column, ['Header', 'defaultMessage'], '')
        })
      : get(column, 'Header', '')
    if (get(column, 'Cell', false))
      column['Cell'] = ({ cell: { value } }) => value
    return column
  })
}
export const isDefaultRouteVM = roleDetail => {
  if (get(roleDetail, [0, 'applicationFeatures'], false)) {
    const applicationFeatures = get(roleDetail, [0, 'applicationFeatures'], [])
    return (
      applicationFeatures.findIndex(
        features => (features.code || '').toUpperCase() === VISITOR_LIST
      ) > -1 &&
      !applicationFeatures.some(features =>
        DASHBOARD_MODULE.includes((features.code || '').toUpperCase())
      )
    )
  } else {
    return false
  }
}

export const hasApplicationFeatureAccess = (auth, featureCode) => {
  const normalizedFeatureCode = (featureCode || '').toUpperCase()
  const applicationFeatures = get(
    auth,
    'userProfileDetail.roleDetail[0].applicationFeatures',
    []
  )

  return applicationFeatures.some(
    feature => (feature.code || '').toUpperCase() === normalizedFeatureCode
  )
}

export function getLastVoyageDate(voyages) {
  if (voyages.length > 0) {
    const voyage = voyages[voyages.length - 1]
    return new Date(get(voyage, 'debarkDate', undefined))
  } else {
    return undefined
  }
}
export function addMonths(date, months) {
  date.setMonth(date.getMonth() + months)
  return date
}

export function checkInValidAgeRange(minAge, maxAge) {
  if (minAge !== '' || maxAge !== '') {
    if (!maxAge) {
      if (minAge >= 0) {
        return true
      }
    }
    if (!minAge) {
      if (maxAge >= 0) {
        return true
      }
    }
    return false
  } else {
    return false
  }
}

export const getRtsStatusLabel = (status, intl) => {
  const normalized = (status || '').toUpperCase()
  if (normalized === rtsStatusCodes.completed) {
    return intl
      ? intl.formatMessage({
          id: 'Guests.rtsStatusCompleted',
          defaultMessage: 'Completed'
        })
      : 'Completed'
  }
  // Accept legacy NON_COMPLETED alias from older payloads
  if (
    normalized === rtsStatusCodes.nonCompleted ||
    normalized === 'NON_COMPLETED'
  ) {
    return intl
      ? intl.formatMessage({
          id: 'Guests.rtsStatusNonCompleted',
          defaultMessage: 'Non-Completed'
        })
      : 'Non-Completed'
  }
  return status || '-'
}

/** Match subgraph mapRtsStatus: missing/unknown Core RTS → NOT_COMPLETED. */
export const normalizeRtsStatusCode = status => {
  const normalized = (status || '').toString().trim().toUpperCase()
  if (normalized === rtsStatusCodes.completed) {
    return rtsStatusCodes.completed
  }
  return rtsStatusCodes.nonCompleted
}

const APPROVED_MOCI_CODES = ['ICPDA', 'A', 'SA']
const REJECTED_MOCI_CODES = [
  'ICM',
  'ICMCN',
  'ICMO',
  'ICMR',
  'SR',
  'R'
]

/** Match subgraph mapMociStatus using verificationStatusCode. */
export const normalizeMociStatusCode = (personOrCode = {}) => {
  let raw = personOrCode
  let hasCode = false
  if (personOrCode && typeof personOrCode === 'object') {
    const code = get(personOrCode, 'verificationStatusCode')
    const nestedCode = get(
      personOrCode,
      'guestGangwayAttrib.verificationStatusCode'
    )
    if (code !== undefined) {
      hasCode = true
      raw = code
    } else if (nestedCode !== undefined) {
      hasCode = true
      raw = nestedCode
    } else {
      raw = get(personOrCode, 'mociStatus') ||
        get(personOrCode, 'guestGangwayAttrib.mociStatus')
    }
  }
  const normalized = (raw || '').toString().trim().toUpperCase()
  if (
    APPROVED_MOCI_CODES.includes(normalized) ||
    (!hasCode && normalized === mociStatusCodes.approved)
  ) {
    return mociStatusCodes.approved
  }
  if (
    REJECTED_MOCI_CODES.includes(normalized) ||
    (!hasCode && normalized === mociStatusCodes.rejected)
  ) {
    return mociStatusCodes.rejected
  }
  if (
    (!hasCode && normalized === mociStatusCodes.pending) ||
    normalized === 'P' ||
    normalized === 'PO'
  ) {
    return mociStatusCodes.pending
  }
  return mociStatusCodes.notReady
}

export const getPersonRtsStatusCode = (person = {}) =>
  normalizeRtsStatusCode(
    get(person, 'rtsStatus') || get(person, 'guestGangwayAttrib.rtsStatus')
  )

export const getPersonMociStatusCode = (person = {}) =>
  normalizeMociStatusCode(person)

export const getMociStatusLabel = (status, intl) => {
  const normalized = (status || '').toUpperCase()
  if (normalized === mociStatusCodes.notReady) {
    return intl
      ? intl.formatMessage({
          id: 'Guests.mociStatusNotReady',
          defaultMessage: 'Not Ready'
        })
      : 'Not Ready'
  }
  if (normalized === mociStatusCodes.approved) {
    return intl
      ? intl.formatMessage({
          id: 'Guests.mociStatusApproved',
          defaultMessage: 'Approved'
        })
      : 'Approved'
  }
  if (normalized === mociStatusCodes.pending) {
    return intl
      ? intl.formatMessage({
          id: 'Guests.mociStatusPending',
          defaultMessage: 'Pending'
        })
      : 'Pending'
  }
  if (normalized === mociStatusCodes.rejected) {
    return intl
      ? intl.formatMessage({
          id: 'Guests.mociStatusRejected',
          defaultMessage: 'Rejected'
        })
      : 'Rejected'
  }
  return status || '-'
}

export const normalizeVisaNumberOfEntries = numberOfEntries => {
  const raw = (numberOfEntries || '').toString().trim().toUpperCase()
  if (!raw) {
    return ''
  }
  // Match subgraph mapVisaEntries: Core may send full words or S/D/M.
  if (raw === visaEntriesCodes.single || raw === 'S') {
    return visaEntriesCodes.single
  }
  if (raw === visaEntriesCodes.double || raw === 'D') {
    return visaEntriesCodes.double
  }
  if (raw === visaEntriesCodes.multiple || raw === 'M') {
    return visaEntriesCodes.multiple
  }
  return ''
}

export const getVisaNumberOfEntriesLabel = (numberOfEntries, intl) => {
  const normalized = normalizeVisaNumberOfEntries(numberOfEntries)
  if (normalized === visaEntriesCodes.single) {
    return intl
      ? intl.formatMessage({
          id: 'Guests.visaEntriesSingle',
          defaultMessage: 'Single'
        })
      : 'Single'
  }
  if (normalized === visaEntriesCodes.double) {
    return intl
      ? intl.formatMessage({
          id: 'Guests.visaEntriesDouble',
          defaultMessage: 'Double'
        })
      : 'Double'
  }
  if (normalized === visaEntriesCodes.multiple) {
    return intl
      ? intl.formatMessage({
          id: 'Guests.visaEntriesMultiple',
          defaultMessage: 'Multiple'
        })
      : 'Multiple'
  }
  return numberOfEntries || ''
}

const isVisaDocument = doc => {
  const type = (doc.typeCode || doc.documentTypeCode || '').toString()
  if (type === DOCUMENT_TYPE_VISA) {
    return true
  }
  // List/subgraph may put visa subtype (B1/B2) in typeCode; numberOfEntries marks a visa.
  const entries = normalizeVisaNumberOfEntries(doc.numberOfEntries)
  return Object.values(visaEntriesCodes).includes(entries)
}

const mapCoreVisasToDocuments = (visas = []) =>
  (visas || [])
    .filter(visa => visa && visa.isDeleted !== true)
    .map(visa => ({
      typeCode: visa.typeCode || visa.visaTypeCode || visa.documentTypeCode,
      documentTypeCode:
        visa.documentTypeCode || visa.visaTypeCode || visa.typeCode,
      issueCountryCode: visa.issueCountryCode,
      number: visa.number,
      numberOfEntries: visa.numberOfEntries
    }))

/** First non-empty docs list. Empty [] must not block fallbacks (|| treats [] as truthy). */
export const getGuestVisaDocuments = (person = {}) => {
  const candidates = [
    get(person, 'guestGangwayAttrib.guestDocuments'),
    get(person, 'guestDocuments'),
    // Core REST (Details / Include party): visas before passport identifications
    mapCoreVisasToDocuments(get(person, 'visas')),
    mapCoreVisasToDocuments(get(person, 'guest.visas')),
    get(person, 'identifications')
  ]
  return candidates.find(docs => !isEmpty(docs)) || []
}

export const getVisaEntriesLabel = (documents = [], countries = [], intl) => {
  const visas = (documents || []).filter(isVisaDocument)
  if (isEmpty(visas)) {
    return intl
      ? intl.formatMessage({
          id: 'Guests.visaEntriesNA',
          defaultMessage: 'NA'
        })
      : 'NA'
  }

  const labels = visas
    .map(visa => {
      const countryCode = visa.issueCountryCode
      const country = (countries || []).find(
        item => item.value === countryCode || item.code === countryCode
      )
      const countryName =
        get(country, 'label') || get(country, 'name') || countryCode || '-'
      const entriesLabel = getVisaNumberOfEntriesLabel(
        visa.numberOfEntries,
        intl
      )
      if (!entriesLabel) {
        return null
      }
      return `${countryName} - ${entriesLabel}`
    })
    .filter(Boolean)

  if (isEmpty(labels)) {
    return intl
      ? intl.formatMessage({
          id: 'Guests.visaEntriesNA',
          defaultMessage: 'NA'
        })
      : 'NA'
  }
  return labels.join(', ')
}

export function getUpdateColumnList(
  event,
  SelectedColumns,
  ismulti,
  columns,
  addedColumns
) {
  if (ismulti) {
    SelectedColumns.forEach(columnObj => {
      const columnIndex = addedColumns.findIndex(
        column => column.accessor === columnObj.accessor
      )
      if (columnObj.isAdded) {
        if (columnIndex === -1) {
          const column = columns.find(
            col => col.accessor === columnObj.accessor
          )
          addedColumns.push(column)
        }
      } else {
        if (columnIndex > -1) {
          addedColumns.splice(columnIndex, 1)
        }
      }
    })
  } else {
    const { name } = event.target
    const columnIndex = addedColumns.findIndex(
      column => column.accessor === name
    )
    if (columnIndex > -1) {
      addedColumns.splice(columnIndex, 1)
    } else {
      const column = columns.find(col => col.accessor === name)
      addedColumns.push(column)
    }
  }
  return addedColumns
}
export const isVaid24hoursFormat = timeSting => {
  const regex = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])$/
  return regex.test(timeSting)
}
export const truncateString = (str, n) => {
  return str.length > n ? str.substr(0, n - 1) + '...' : str
}

export const getUserName = (
  userInfoObj,
  isGetUserNameWithDesignation = false,
  isOnlyShowDesignation = false
) => {
  let fullName =
    get(userInfoObj, 'firstName', '') + ' ' + get(userInfoObj, 'lastName', '')
  if (isOnlyShowDesignation) {
    return !isEmpty(get(userInfoObj, 'designation'))
      ? userInfoObj.designation
      : fullName
  }
  if (
    isGetUserNameWithDesignation &&
    !isEmpty(get(userInfoObj, 'designation'))
  ) {
    fullName = fullName + ' - ' + userInfoObj.designation
  }
  return fullName
}
export const getUniqDesignation = userList => {
  return uniqBy(removeEmptyValueByKey(userList, 'designation'), 'designation')
}

export const removeEmptyValueByKey = (userList, key) => {
  return isEmpty(key)
    ? userList
    : userList.filter(user => {
        return get(user, key, '') !== ''
      })
}
export const userMapByDesignation = userList => {
  let userListData = getUniqDesignation(userList)
  let test = userListData.map(user => {
    return {
      name: user.designation,
      value: valueToKey(user.designation),
      id: valueToKey(user.designation)
    }
  })
  return test
}

export const valueToKey = value => {
  return value ? value.replace(/ /g, '_') : ''
}
export const keyToValue = value => {
  return value ? value.replace(/_/g, ' ') : ''
}
export const getUserIdByDesignation = (designationsList, designationGroup) => {
  let userListID = []
  designationsList.map(designation => {
    const myList = get(designationGroup, keyToValue(designation))
    if (myList) {
      userListID.push(...myList)
    }
  })
  return userListID
}

export const getSecurityOfficerCrew = reviewerList => {
  return reviewerList.find(
    user => user.designation === SECURITY_OFFICER_DESIGNATION
  )
}

export const getGroupByDesignation = userList => {
  return removeEmptyValueByKey(userList, 'designation').reduce(
    (groupData, { designation, reviewerTeamMemberId }) => {
      if (!groupData[designation]) groupData[designation] = []
      groupData[designation].push(reviewerTeamMemberId)
      return groupData
    },
    {}
  )
}
export const getSecurityOfficerUserCrewID = reviewerList => {
  return get(
    reviewerList.find(
      user => user.designation === SECURITY_OFFICER_DESIGNATION
    ),
    'reviewerTeamMemberId',
    ''
  )
}
export const isCanBulkApprove = userRoles => {
  return userRoles.some(
    role =>
      (role.code || '').toUpperCase() === SecurityAdmin ||
      (role.code || '').toUpperCase() === SHORE_SIDE_SECURITY_ADMIN ||
      (role.code || '').toUpperCase() === ApproverRole
  )
}
export const isUserRoleRequesterOnly = userRoles => {
  return (
    !userRoles.some(
      role =>
        (role.code || '').toUpperCase() === SecurityAdmin ||
        (role.code || '').toUpperCase() === SHORE_SIDE_SECURITY_ADMIN ||
        (role.code || '').toUpperCase() === OFFICE_ADMIN ||
        (role.code || '').toUpperCase() === ApproverRole
    ) &&
    userRoles.some(role => (role.code || '').toUpperCase() === RequestorRole)
  )
}
export const ipmGroupSelector = (ipmGroups = []) => {
  let ipmGroupsData = cloneDeep(ipmGroups)
  return ipmGroupsData.map(ipmGroup => {
    return {
      ...ipmGroup,
      name: ipmGroup.groupName || '',
      label: ipmGroup.groupName || '',
      value: ipmGroup.code || ''
    }
  })
}
export const isAccessTokenValid = () => {
  return (
    localStorage.getItem(APP_AUTH_NAME) &&
    isSameOrBefore(
      new Date(),
      JSON.parse(localStorage.getItem(APP_AUTH_NAME)).expireDate
    )
  )
}
export const removeKeyFromObject = (reqObject, removeKeys) => {
  if (isEmpty(removeKeys)) return reqObject
  removeKeys.forEach(item => delete reqObject[item])
  return reqObject
}
export const checkSameValueExistInArray = (arr1, arr2) => {
  return arr1.some(item => arr2.includes(item))
}

const AUTH_STORAGE_KEY = 'auth'
const AUTH_REMEMBER_ME_KEY = 'authRememberMe'
const AUTH_SESSION_COOKIE = 'embarkationAuthSession'
const ACTIVE_SHIP_STORAGE_KEY = 'activeShip'
const ACTIVE_VOYAGE_STORAGE_PREFIX = 'activeVoyage_'
const TAB_ACTIVE_SHIP_KEY = 'tabActiveShip'
const TAB_ACTIVE_VOYAGE_PREFIX = 'tabActiveVoyage_'
const PENDING_ROUTE_STORAGE_KEY = 'embarkationPendingRoute'
const NEW_TAB_DETAIL_SESSION_KEY = 'newTabDetailSession'

const getAuthCookiePath = () => '/'

export const setAuthSessionCookie = () => {
  document.cookie = `${AUTH_SESSION_COOKIE}=active; path=${getAuthCookiePath()}; SameSite=Lax`
}

export const hasAuthSessionCookie = () => {
  return getCookieValue(AUTH_SESSION_COOKIE) === 'active'
}

export const getAppContext = () => get(window, '__APP_ENV__.CONTEXT', '')

export const clearAuthSessionCookie = () => {
  const expires = 'Thu, 01 Jan 1970 00:00:00 GMT'
  const context = getAppContext()
  const legacyPath = context ? `/${context}/` : '/'
  document.cookie = `${AUTH_SESSION_COOKIE}=; path=${getAuthCookiePath()}; expires=${expires}`
  if (legacyPath !== getAuthCookiePath()) {
    document.cookie = `${AUTH_SESSION_COOKIE}=; path=${legacyPath}; expires=${expires}`
  }
}

export const saveAuthToStorage = (authData, rememberMe = false) => {
  const serialized = JSON.stringify(authData)
  if (rememberMe) {
    localStorage.setItem(AUTH_STORAGE_KEY, serialized)
    localStorage.setItem(AUTH_REMEMBER_ME_KEY, 'true')
    sessionStorage.removeItem(AUTH_STORAGE_KEY)
    clearAuthSessionCookie()
  } else {
    sessionStorage.setItem(AUTH_STORAGE_KEY, serialized)
    localStorage.setItem(AUTH_STORAGE_KEY, serialized)
    localStorage.setItem(AUTH_REMEMBER_ME_KEY, 'false')
    setAuthSessionCookie()
  }
}

export const clearAuthFromStorage = () => {
  localStorage.removeItem(AUTH_STORAGE_KEY)
  sessionStorage.removeItem(AUTH_STORAGE_KEY)
  localStorage.removeItem(AUTH_REMEMBER_ME_KEY)
  clearAuthSessionCookie()
  clearActiveShipFromStorage()
  clearActiveVoyageFromStorage()
  sessionStorage.removeItem(PENDING_ROUTE_STORAGE_KEY)
}

export const isVisitorDetailRoute = pathname => {
  if (!pathname) {
    return false
  }
  const context = get(window, '__APP_ENV__.CONTEXT', '')
  const base = context ? `/${context}` : ''
  const visitorDetailPattern = new RegExp(`^${base}/${routes.visitor}/[^/]+/?$`)
  return visitorDetailPattern.test(pathname.split('?')[0])
}

export const isPersonDetailRoute = pathname => {
  if (!pathname) {
    return false
  }
  const context = get(window, '__APP_ENV__.CONTEXT', '')
  const base = context ? `/${context}` : ''
  const detailPattern = new RegExp(
    `^${base}/(${routes.guest}|${routes.crew}|${routes.visitor})/[^/]+/?$`
  )
  return detailPattern.test(pathname.split('?')[0])
}

export const isPageReload = () => {
  if (typeof performance === 'undefined') {
    return false
  }
  const [navigation] = performance.getEntriesByType('navigation')
  if (navigation) {
    return navigation.type === 'reload'
  }
  return performance.navigation?.type === 1
}

export const isNewTabDetailSession = () =>
  sessionStorage.getItem(NEW_TAB_DETAIL_SESSION_KEY) === 'true'

const markNewTabDetailSession = () => {
  sessionStorage.setItem(NEW_TAB_DETAIL_SESSION_KEY, 'true')
}

export const saveActiveShipToStorage = shipCode => {
  if (shipCode) {
    sessionStorage.setItem(TAB_ACTIVE_SHIP_KEY, shipCode)
    localStorage.setItem(ACTIVE_SHIP_STORAGE_KEY, shipCode)
  }
}

export const getActiveShipFromStorage = () =>
  localStorage.getItem(ACTIVE_SHIP_STORAGE_KEY) || ''

export const getTabActiveShip = () =>
  sessionStorage.getItem(TAB_ACTIVE_SHIP_KEY) || ''

export const isShoreEnvironment = settings =>
  get(settings, 'env.location', '').toLowerCase() === 'shore'

export const clearActiveShipFromStorage = () => {
  localStorage.removeItem(ACTIVE_SHIP_STORAGE_KEY)
  sessionStorage.removeItem(TAB_ACTIVE_SHIP_KEY)
}

const getTabActiveVoyageStorageKey = shipCode =>
  `${TAB_ACTIVE_VOYAGE_PREFIX}${shipCode}`

export const savePendingRoute = route => {
  if (
    route &&
    isPersonDetailRoute(route) &&
    !route.includes('select-ship') &&
    !route.includes('login')
  ) {
    sessionStorage.setItem(PENDING_ROUTE_STORAGE_KEY, route)
  }
}

export const consumePendingRoute = () => {
  const route = sessionStorage.getItem(PENDING_ROUTE_STORAGE_KEY)
  sessionStorage.removeItem(PENDING_ROUTE_STORAGE_KEY)
  return route || ''
}

const getActiveVoyageStorageKey = shipCode =>
  `${ACTIVE_VOYAGE_STORAGE_PREFIX}${shipCode}`

const serializeSavedVoyageRef = voyage => ({
  voyageNumber: voyage.voyageNumber,
  voyageId: voyage.voyageId,
  isPastVoyage: voyage.isPastVoyage || false
})

export const saveActiveVoyageToStorage = (voyage, shipCode) => {
  if (!isEmpty(voyage) && shipCode) {
    const serializedVoyage = JSON.stringify(serializeSavedVoyageRef(voyage))
    sessionStorage.setItem(
      getTabActiveVoyageStorageKey(shipCode),
      serializedVoyage
    )
    localStorage.setItem(getActiveVoyageStorageKey(shipCode), serializedVoyage)
  }
}

export const getSavedVoyageFromStorage = shipCode => {
  if (!shipCode) return null
  const raw = localStorage.getItem(getActiveVoyageStorageKey(shipCode))
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export const getSavedVoyageForTab = shipCode => {
  if (!shipCode) return null
  const tabVoyage = sessionStorage.getItem(
    getTabActiveVoyageStorageKey(shipCode)
  )
  if (!tabVoyage) return null
  try {
    return JSON.parse(tabVoyage)
  } catch (e) {
    return null
  }
}

export const clearActiveVoyageFromStorage = shipCode => {
  if (shipCode) {
    localStorage.removeItem(getActiveVoyageStorageKey(shipCode))
    sessionStorage.removeItem(getTabActiveVoyageStorageKey(shipCode))
    return
  }
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith(ACTIVE_VOYAGE_STORAGE_PREFIX)) {
      localStorage.removeItem(key)
    }
  })
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith(TAB_ACTIVE_VOYAGE_PREFIX)) {
      sessionStorage.removeItem(key)
    }
  })
}

export const getCurrentAppPath = () =>
  `${window.location.pathname}${window.location.search}`

export const isAppRootPath = (currentPath, appBasePath) => {
  const [pathWithoutQuery] = (currentPath || '').split('?')
  return (
    pathWithoutQuery === appBasePath ||
    pathWithoutQuery === `${appBasePath}/`
  )
}

export const getDefaultAppRoute = (appBasePath, preferVisitorsDefault) =>
  preferVisitorsDefault
    ? `${appBasePath}/${routes.visitors}`
    : `${appBasePath}/${routes.dashboard}`

export const getSavedTabShipForDetailRoute = (activeShip, currentPath) => {
  const savedShip = getTabActiveShip()
  if (savedShip && isEmpty(activeShip) && isPersonDetailRoute(currentPath)) {
    return savedShip
  }
  return null
}

export const shouldFetchMasterdata = ({
  activeShip,
  settings,
  startup,
  isClientWithUrlSet,
  isShore
}) => {
  if (isEmpty(activeShip) || isEmpty(settings) || !isClientWithUrlSet) {
    return false
  }
  const isShoreSide = isShore || isShoreEnvironment(settings)
  return isShoreSide || !isEmpty(startup)
}

export const resolveVoyageFromMasterdata = (masterdata, savedVoyageRef) => {
  if (isEmpty(masterdata)) return null

  const allVoyages = [
    ...get(masterdata, 'pastVoyages', []),
    ...get(masterdata, 'currentFutureVoyages', []),
    ...get(masterdata, 'voyages', [])
  ]
  const uniqueVoyages = allVoyages.filter(
    (voyage, index, voyages) =>
      voyages.findIndex(item => item.voyageNumber === voyage.voyageNumber) ===
      index
  )

  if (savedVoyageRef) {
    const matchedVoyage = uniqueVoyages.find(
      voyage =>
        voyage.voyageNumber === savedVoyageRef.voyageNumber ||
        (savedVoyageRef.voyageId && voyage.voyageId === savedVoyageRef.voyageId)
    )
    if (matchedVoyage) return matchedVoyage
  }

  const activeVoyage = get(masterdata, 'voyages', []).find(
    voyage => voyage.isActive
  )
  if (activeVoyage) return activeVoyage

  const currentFutureVoyages = get(masterdata, 'currentFutureVoyages', [])
  if (currentFutureVoyages.length > 0) return currentFutureVoyages[0]

  return uniqueVoyages[0] || null
}

export const getVoyageToRestore = (masterdata, activeShip, isShoreSide) => {
  if (isEmpty(masterdata) || isEmpty(activeShip)) {
    return null
  }

  const savedVoyageRef = getSavedVoyageForTab(activeShip)
  if (isShoreSide && isEmpty(savedVoyageRef)) {
    return null
  }

  const voyage = resolveVoyageFromMasterdata(masterdata, savedVoyageRef)
  if (isEmpty(voyage)) {
    return null
  }

  return {
    voyage,
    isPastVoyage: Boolean(voyage.isPastVoyage || savedVoyageRef?.isPastVoyage)
  }
}

export const isPersonDetailRouteContextLoading = ({
  currentPath,
  accessToken,
  activeShip,
  startup,
  masterdata,
  activeVoyage
}) => {
  if (
    !isPersonDetailRoute(currentPath) ||
    isEmpty(accessToken) ||
    isEmpty(activeShip) ||
    isEmpty(startup)
  ) {
    return false
  }

  if (isEmpty(masterdata)) {
    return true
  }

  // Visitor detail loads from visitorId + masterdata; voyage is optional.
  if (isVisitorDetailRoute(currentPath)) {
    return false
  }

  return isEmpty(activeVoyage)
}

const clearTabSessionContext = () => {
  sessionStorage.removeItem(TAB_ACTIVE_SHIP_KEY)
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith(TAB_ACTIVE_VOYAGE_PREFIX)) {
      sessionStorage.removeItem(key)
    }
  })
}

const seedAuthForNewTab = () => {
  if (sessionStorage.getItem(AUTH_STORAGE_KEY) !== null) {
    return
  }

  const localAuth = localStorage.getItem(AUTH_STORAGE_KEY)
  if (!localAuth) {
    return
  }

  try {
    if (isEmpty(JSON.parse(localAuth))) {
      return
    }
  } catch (e) {
    return
  }

  sessionStorage.setItem(AUTH_STORAGE_KEY, localAuth)
  const rememberMe = localStorage.getItem(AUTH_REMEMBER_ME_KEY)
  if (rememberMe === 'false' && !hasAuthSessionCookie()) {
    setAuthSessionCookie()
  }
}

const seedTabContextFromSharedStorage = () => {
  const sharedShip = getActiveShipFromStorage()
  if (sharedShip && !getTabActiveShip()) {
    sessionStorage.setItem(TAB_ACTIVE_SHIP_KEY, sharedShip)
  }
  if (sharedShip) {
    const sharedVoyage = getSavedVoyageFromStorage(sharedShip)
    if (sharedVoyage) {
      const tabVoyageKey = getTabActiveVoyageStorageKey(sharedShip)
      if (!sessionStorage.getItem(tabVoyageKey)) {
        sessionStorage.setItem(
          tabVoyageKey,
          JSON.stringify(serializeSavedVoyageRef(sharedVoyage))
        )
      }
    }
  }
}

export const initializeTabContext = () => {
  const currentPath = `${window.location.pathname}${window.location.search}`

  if (isPageReload()) {
    clearTabSessionContext()
    return
  }

  if (isPersonDetailRoute(currentPath)) {
    markNewTabDetailSession()
    seedAuthForNewTab()
    seedTabContextFromSharedStorage()
  }
}

export const setAuthDataInStore = (
  tokenDetail,
  authCookieName = AUTH_STORAGE_KEY
) => {
  const updateStorage = storage => {
    const current = storage.getItem(authCookieName)
    if (!isEmpty(current)) {
      let currentDataInStore = JSON.parse(current)
      currentDataInStore['tokenDetail'] = {
        ...currentDataInStore['tokenDetail'],
        ...tokenDetail
      }
      storage.setItem(authCookieName, JSON.stringify(currentDataInStore))
    }
  }
  updateStorage(sessionStorage)
  updateStorage(localStorage)
}
export const initializeRefreshToken = getAuthData => {
  if (!get(authHandlerObject, 'authHandler', false)) {
    authHandlerObject.authHandler = getRefreshTokenObject(getAuthData)
  }
  authHandlerObject.authHandler.initializeToken()
}

export const getRefreshTokenObject = getAuthData => {
  return new AuthenticationHandler({
    authenticatorServiceUrl: '/identityaccessmanagement-service/', //get( window, '__APP_ENV__.identityaccessmanagement' ) || get( window, '__APP_ENV__.IDENTITY_ACCESS_MANAGEMENT_SERVICE_URL' ),
    expiresIn: get(getAuthData, 'tokenDetail.expiresIn', ''),
    basicToken: get(window, '__APP_ENV__.BASIC_TOKEN'),
    refreshToken: get(getAuthData, 'tokenDetail.refreshToken', ''),
    accessToken: get(getAuthData, 'tokenDetail.accessToken', ''),
    applicationName: APP_AUTH_NAME
  })
}

export const getAuthDataFromStorage = () => {
  const sessionAuth = sessionStorage.getItem(AUTH_STORAGE_KEY)
  if (sessionAuth !== null) {
    try {
      const parsed = JSON.parse(sessionAuth)
      if (!isEmpty(parsed)) {
        return parsed
      }
    } catch (e) {
      // ignore invalid JSON
    }
  }

  const currentPath = `${window.location.pathname}${window.location.search}`
  if (!isPageReload() && !isPersonDetailRoute(currentPath)) {
    return null
  }

  const localAuth = localStorage.getItem(AUTH_STORAGE_KEY)
  if (localAuth === null) {
    return null
  }

  try {
    const parsed = JSON.parse(localAuth)
    if (isEmpty(parsed)) {
      return null
    }

    if (
      localStorage.getItem(AUTH_REMEMBER_ME_KEY) === 'false' &&
      !hasAuthSessionCookie()
    ) {
      if (isPageReload()) {
        clearAuthFromStorage()
      }
      return null
    }

    return parsed
  } catch (e) {
    return null
  }
}
export const buildVisitsBody = (visits = []) => {
  let newVisits = []
  visits.forEach(visit => {
    if (visit.isDurationVisit) {
      visit.validForShip.map(shipCode => {
        newVisits.push({
          ...visit,
          validForShip: shipCode
        })
      })
    } else {
      newVisits.push(visit)
    }
  })
  return newVisits
}

export const filterShips = (ships, filterShipCodes = []) => {
  if (filterShipCodes.length > 0) {
    const allowShipcode = filterShipCodes
    return ships.filter(ship => allowShipcode.includes(ship.shipCode))
  }
  return ships
}
export const shipsLableChangeAsCode = (ships = []) => {
  return ships.map(ship => {
    return { ...ship, label: ship.value }
  })
}
export const stringArrayParse = stringArr => {
  if (!isEmpty(stringArr)) {
    stringArr = stringArr.replace(/'/g, '"')
    return JSON.parse(stringArr)
  } else {
    return []
  }
}

export const isOverlapsRangeDates = ranges => {
  let overlaps = 0
  for (let i = 0; i < ranges.length; i++) {
    const range1 = ranges[i]

    for (let j = i + 1; j < ranges.length; j++) {
      const range2 = ranges[j]

      if (
        !(
          range1.startDate >= range2.endDate ||
          range2.endDate <= range1.startDate ||
          range2.startDate >= range1.endDate ||
          range1.endDate <= range2.startDate
        )
      ) {
        let duplicateValidForShip = covertStringToArray(
          ranges[i].validForShip
        ).filter(
          e => covertStringToArray(ranges[j].validForShip).indexOf(e) !== -1
        )
        if (duplicateValidForShip.length > 0) {
          overlaps++
          return {
            isValid: false,
            message: `visit ${j + 1} overlaps visit ${i + 1}`
          }
        }
      }
    }
  }
  return { isValid: overlaps === 0, message: '' }
}
export const covertStringToArray = value => {
  if (typeof value === 'string' || value instanceof String) {
    return [value]
  }
  return value
}
export const checkISDurationVisit = visit => {
  return !(
    convertDateTo_YYYY_MM_DD(visit.startDate) ===
    convertDateTo_YYYY_MM_DD(visit.endDate)
  )
}
export const getConfigDetails = param => ({
  baseURL: get(param, 'baseURL'),
  headers: {
    Accept: get(param, 'headers.Accept'),
    CorrelationId: get(param, 'headers.CorrelationId'),
    maxContentLength: get(param, 'headers.maxContentLength'),
    method: get(param, 'headers.method'),
    timeout: get(param, 'headers.timeout')
  },
  maxContentLength: get(param, 'maxContentLength'),
  method: get(param, 'method'),
  timeout: get(param, 'timeout'),
  url: get(param, 'url'),
  xsrfCookieName: get(param, 'xsrfCookieName'),
  xsrfHeaderName: get(param, 'xsrfHeaderName')
})

export const getResponseDetails = param => ({
  config: {
    baseURL: get(param, 'config.baseURL'),
    headers: {
      Accept: get(param, 'config.headers.Accept'),
      CorrelationId: get(param, 'config.headers.CorrelationId')
    },
    maxContentLength: get(param, 'maxContentLength'),
    method: get(param, 'method'),
    timeout: get(param, 'timeout'),
    url: get(param, 'url'),
    xsrfCookieName: get(param, 'xsrfCookieName'),
    xsrfHeaderName: get(param, 'xsrfHeaderName')
  },
  headers: get(param, 'headers'),
  request: get(param, 'request'),
  status: get(param, 'status'),
  statusText: get(param, 'statusText')
})

export const extractLinkIdGroupVisit = visits => {
  let visitsData = cloneDeep(visits)
  let extractVisits = []
  visitsData.forEach(visit => {
    if (!checkISDurationVisit(visit)) {
      extractVisits.push(visit)
    } else {
      if (get(visit, 'linkIdVisits', []).length > 1) {
        visit.linkIdVisits.forEach(linkVisit => extractVisits.push(linkVisit))
      } else {
        delete visit.linkIdVisits
        extractVisits.push(visit)
      }
    }
  })
  return extractVisits
}
export const checkVisitorHaveDurationVisit = (visitor = [], shipTime) => {
  return get(visitor, 'visits', [])
    .filter(visit => {
      return isBefore(convertDateTo_YYYY_MM_DD(shipTime), visit.startDate)
    })
    .some(visit => checkISDurationVisit(visit))
}

export const checkIsVipOrPriorityBoardingSlotChecked = (
  checkedBoardingGroups,
  vipOrPrioriryBoardingNumber
) => {
  if (!isEmpty(checkedBoardingGroups)) {
    return (
      checkedBoardingGroups.findIndex(
        item => item.boardingNumber === vipOrPrioriryBoardingNumber
      ) > -1
    )
  } else {
    return false
  }
}
export const removeEmptyValueFromObject = valueObj => {
  return omitBy(valueObj, v => isEmpty(v))
}
export const setLoggedInUserData = userData => {
  if (!isEmpty(userData.userProfileDetail)) {
    let loggedInUserDetail = { crewId: userData.userProfileDetail.crewId }
    setMetaData({ loggedInUserDetail: loggedInUserDetail })
  }
}
export const setPersonDetail = (personTypeKey, personDetail) => {
  if (!isEmpty(personDetail)) {
    setMetaData({ [personTypeKey]: personDetail })
  }
}
export const removeLogMetaDataByKey = key => {
  if (!isEmpty(key)) {
    removeMetaData(key)
  }
}

export const getBaseURL = url => {
  let urlObj = new URL(url)
  return urlObj.origin
}

export const joinUrl = (baseURL, Path) => {
  return `${baseURL}${Path}`
}

export const labelWithCount = (label, count) => {
  return `${label} ${count > 0 ? `(${count})` : ''}`
}

export const mapArrayWithLabelAndValueKey = results => {
  return results.length > 0
    ? results.map(result => {
        return { label: capitalizeFirstChar(result), value: result }
      })
    : []
}

export const capitalizeFirstChar = text => {
  if (text && isString(text)) {
    return text[0].toUpperCase() + text.slice(1)
  }

  return text
}
export const isVipOrPriorirySlotMatch = (
  boardingSlots1,
  boardingSlots2,
  vipOrPrioriryBoardingNumber
) => {
  let boardAnytime1 = boardingSlots1.find(
    slot => slot.boardingNumber === vipOrPrioriryBoardingNumber
  )
  let boardAnytime2 = boardingSlots2.find(
    slot => slot.boardingNumber === vipOrPrioriryBoardingNumber
  )
  return !isEmpty(boardAnytime1) && !isEmpty(boardAnytime2)
    ? boardAnytime1.boardingSlotStartTime ==
        boardAnytime2.boardingSlotStartTime &&
        boardAnytime1.boardingSlotEndTime == boardAnytime2.boardingSlotEndTime
    : false
}
export const filterSwFareCodes = (fareCodes = []) =>
  (Array.isArray(fareCodes) ? fareCodes : []).filter(
    fc =>
      fc &&
      !fc.isDeleted &&
      SW_FARE_CODE_ALLOWLIST.includes((fc.fareCode || '').toUpperCase())
  )

export const lookupMasterdataName = (items = [], code) => {
  const item = (items || []).find(entry => entry.code === code)
  return get(item, 'name', '') || get(item, 'label', '')
}

const swInfoList = value => (Array.isArray(value) ? value : [])

export const swInfoTextOrNa = value => {
  const text = value == null ? '' : String(value).trim()
  return text || 'NA'
}

const swInfoLinesOrNa = lines => (lines.length ? lines : ['NA'])

const liveSwInfoAgencies = guestDetails => {
  const agencies = get(guestDetails, 'agencies')
  if (Array.isArray(agencies) && agencies.length > 0) {
    return agencies.filter(agency => agency && !get(agency, 'deleted', false))
  }
  const guestAgency = get(guestDetails, 'guestAgency')
  if (guestAgency && !get(guestAgency, 'deleted', false)) {
    return [guestAgency]
  }
  return []
}

/** Lines for the SW Info modal. An empty section is one "NA" row. */
export const buildSwInfoDisplay = (
  guestDetails = {},
  celebrationMaster = []
) => {
  const loyalty = swInfoList(get(guestDetails, 'loyaltyInfo'))
    .filter(item => item && !get(item, 'isDeleted', false))
    .flatMap(item => [
      `Loyalty Level Program ID - ${swInfoTextOrNa(get(item, 'programId'))}`,
      `Loyalty Level - ${swInfoTextOrNa(get(item, 'loyalLevel'))}`
    ])
  const agency = liveSwInfoAgencies(guestDetails).flatMap(item => [
    `Contact: ${swInfoTextOrNa(get(item, 'name'))}`,
    `Agency ID: ${swInfoTextOrNa(get(item, 'externalRefId'))}`
  ])
  const fareCodes = filterSwFareCodes(
    swInfoList(get(guestDetails, 'fareCodes'))
  ).map(item => swInfoTextOrNa(get(item, 'fareCode')))
  const celebrations = swInfoList(get(guestDetails, 'guestCelebrations'))
    .filter(item => item && !get(item, 'isDeleted', false))
    .map(item =>
      swInfoTextOrNa(
        lookupMasterdataName(
          swInfoList(celebrationMaster),
          get(item, 'celebrationCode', '')
        ) || get(item, 'celebrationCode', '')
      )
    )

  return {
    loyalty: swInfoLinesOrNa(loyalty),
    agency: swInfoLinesOrNa(agency),
    fareCodes: swInfoLinesOrNa(fareCodes),
    celebrations: swInfoLinesOrNa(celebrations)
  }
}

export const getAddOnDisplayLabel = (preference = {}, masterPreferences = []) =>
  lookupMasterdataName(masterPreferences, preference.preferenceValueCode) ||
  preference.preferenceValueCode ||
  preference.additionalPreference ||
  preference.preferenceCode ||
  ''

export const filterSpecialNeeds = (masterData, specialNeedCodes) => {
  const specialNeeds = get(masterData, 'specialNeeds', [])
  let filteredSpecialNeeds = []
  filteredSpecialNeeds = specialNeeds.filter(({ code }) =>
    specialNeedCodes.includes(code)
  )
  if (
    filteredSpecialNeeds.length !== specialNeedCodes.length &&
    filteredSpecialNeeds.length !== 0
  ) {
    const preferences = get(masterData, 'preferences', [])
    filteredSpecialNeeds = [
      ...filteredSpecialNeeds,
      ...preferences.filter(({ code }) => specialNeedCodes.includes(code))
    ]
  }

  return filteredSpecialNeeds
}
export const mapStartupData = (shipCode, visitorMediaGroupId, pathsObj) => {
  const {
    crewbff,
    identityaccessmanagement,
    dxpcore,
    dxpbatchjob,
    messaging,
    graphql,
    contentmanagement
  } = pathsObj
  return {
    loginURL: joinUrl(crewbff, LOGIN_URL),
    visitorProfileUploadURL: joinUrl(
      dxpcore,
      `${VISITOR_MEDIA_URL}?mediagroupid=${visitorMediaGroupId}`
    ),
    reservationGuestListURL: joinUrl(crewbff, RESERVATION_GUEST_LIST),
    logURL: joinUrl(crewbff, LOGS),
    multimediaURL: joinUrl(dxpcore, `${VISITOR_MEDIA_URL}/`),
    uiConfigURL: joinUrl(crewbff, UI_CONFIG),
    searchURL: joinUrl(crewbff, GLOBAL_SEARCH),
    stateroomsListURL: joinUrl(crewbff, STATEROOMS_LIST),
    shipCode,
    resourcesUrl: joinUrl(crewbff, RESOURCES),
    slotsUrl: joinUrl(crewbff, SLOTS),
    guestsFilterUrl: joinUrl(crewbff, RESERVATION_GUESTS_SEARCH),
    locationReportUrl: joinUrl(dxpcore, LOCATION_REPORT),
    ipmSingleAssignUrl: joinUrl(crewbff, IPM_SINGLE_ASSIGN),
    ipmSingleUnassignUrl: joinUrl(crewbff, IPM_SINGLE_UNASSIGN),
    importVisitorUrl: joinUrl(dxpcore, VISITOR_IMPORT),
    guesttypesUrl: joinUrl(dxpcore, GUESTTYPES_URL),
    createReservationUrl: joinUrl(dxpcore, CREATE_RESERVATION_URL),
    ipmDutyImportUrl: joinUrl(dxpcore, IPM_IMPORT_URL),
    ipmPercentageConfigImportUrl: joinUrl(
      dxpcore,
      IPM_PERCENTAGE_CONFIG_IMPORT_URL
    ),
    stateroomsSearchURL: joinUrl(dxpcore, STATEROOMS_SEARCH),
    stateroomGuestsURL: joinUrl(dxpcore, RESERVATIONGUESTS_SEARCH),
    getGuestReservationURL: joinUrl(dxpcore, GET_GUESTRESERVATION),
    getStateroomCategoryURL: joinUrl(dxpcore, GET_STATEROOMCATEGORIES),
    getStateroomCapacityURL: joinUrl(dxpcore, GET_STATEROOMCAPACITIES),
    postStateroomStatusUpdateURL: joinUrl(dxpcore, POST_STATEROOMSTATUS),
    reservationguestStateroomURL: joinUrl(dxpcore, RESERVATION_GUESTS),
    guestStateroomPartyURL: joinUrl(dxpcore, GUEST_STATEROOMPARTY_URL),
    guestSearchPartyURL: joinUrl(dxpcore, GUEST_SEARCHPARTY_URL),
    upgradeGuestsStateroomURL: joinUrl(dxpcore, UPGRADE_STATEROOM_URL),
    voyagesURL: joinUrl(dxpcore, VOYAGES_URL),
    reservationguestsStatusURL: joinUrl(dxpcore, RESERVATIONGUESTS_BATCHURL),
    reservationGuestUpdateURL: joinUrl(dxpcore, RESERVATION_GUESTUPDATE_URL),
    alertMessageDetailsURL: joinUrl(messaging, ALERTMESSAGE_DETAILURL),
    iamPersonDetailURL: joinUrl(identityaccessmanagement, PERSONDETAILS_GET),
    attributeURL: joinUrl(dxpcore, ATTRIBUTE_URL),
    alertsReportUrl: joinUrl(dxpcore, ALERT_REPORT_URL),
    exportVisitorUrl: joinUrl(dxpcore, EXPORT_VISITOR_URL),
    graphql,
    exportBoardingSlotHistoryUrl: joinUrl(
      dxpcore,
      EXPORT_BOARDING_SLOT_HISTORY_REPORT_URL
    ),
    exportGuestFlightDetailsUrl: joinUrl(
      dxpcore,
      EXPORT_GUEST_FLIGHT_DETAILS_REPORT_URL
    ),
    exportDocumentBreakdownUrl: joinUrl(
      dxpcore,
      EXPORT_DOC_TYPE_BREAKDOWN_URL
    ),
    exportDocumentWiseSailorUrl: joinUrl(
      dxpcore,
      EXPORT_DOC_WISE_SAILOR_URL
    ),
    exportSailorNationalityUrl: joinUrl(
      dxpcore,
      EXPORT_SAILOR_NATIONALITY_URL
    ),
    exportCitizenshipWiseSailorUrl: joinUrl(
      dxpcore,
      EXPORT_NATIONALITY_WISE_SAILOR_URL
    ),
    exportBoardingSlotUrl: joinUrl(dxpcore, EXPORT_BOARDING_SLOT_REPORT_URL),
    exportLocationHistoryUrl: joinUrl(
      dxpcore,
      EXPORT_LOCATION_HISTORY_REPORT_URL
    ),
    updateMasterDataURL: joinUrl(dxpcore, UPDATE_MASTER_DATA_URL),
    guestBoardingExceptionReportURL: joinUrl(
      dxpcore,
      BOARDING_EXCEPTION_REPORT_URL
    ),
    sailorVipIconURL: joinUrl(contentmanagement, SAILOR_VIP_ICONS_URL),
    cbpMessageScheduleUrl: joinUrl(dxpbatchjob, CBP_MESSAGE_SCHEDULE_URL),
    cbpVcoMessageUrl: joinUrl(dxpbatchjob, CBP_VCO_MESSAGE_URL),
    cbpLatestEnoadUrl: joinUrl(dxpbatchjob, CBP_LATEST_ENOAD_URL),
    cbpSendVcoMessageUrl: joinUrl(dxpbatchjob, CBP_SEND_VCO_MESSAGE_URL),
    cbpSendBatchMessageUrl: joinUrl(dxpbatchjob, CBP_SEND_BATCH_MESSAGE_URL),
    cbpDownloadEnoadUrl: joinUrl(dxpbatchjob, CBP_DOWNLOAD_ENOAD_URL),
    cbpComparatorUrl: joinUrl(dxpbatchjob, CBP_COMPARATOR_URL),
    cbpGenerateEnoadBatchUrl: joinUrl(
      dxpbatchjob,
      CBP_GENERATE_ENOAD_BATCH_URL
    ),
    getLegsUrl: joinUrl(dxpbatchjob, CBP_GET_LEGS_URL)
  }
}

export const isVipOrPriorityBoardingNumber = (
  vipBoardingNumber,
  priorityBoardingNumber,
  boardingNumber
) => {
  return [vipBoardingNumber, priorityBoardingNumber].includes(boardingNumber)
}

export const getMessageTypeByCode = (messageTypes, code) => {
  return messageTypes.find(msgType => msgType.value === code)
}

// getting current, 1 past and 2 future voyage on this function
export const getSpecificVoyageListForCbp = voyages => {
  let sortedVoyages = sortBy(voyages, 'embarkDate')
  const activeVoyageIndex = sortedVoyages.findIndex(item => item.isActive)
  if (activeVoyageIndex >= 0) {
    const start =
      activeVoyageIndex < 1 ? activeVoyageIndex : activeVoyageIndex - 1
    const end = activeVoyageIndex + 3
    sortedVoyages = sortedVoyages.slice(start, end)
  }
  return sortedVoyages
}

export const getOrNull = (obj, path) => {
  const value = get(obj, path, null)
  return Array.isArray(value) && value.length === 0 ? null : value
}

export const getBlobfromBase64 = (base64result, sliceSize, contentType) => {
  if (!isEmpty(base64result)) {
    let byteCharacters = window.atob(base64result)
    let byteArrays = []
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize)
      let byteNumbers = []
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }
      let byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }
    return new Blob(byteArrays, { type: contentType })
  }
  return new Blob()
}

export const getPersonTypeCodeBaseRoutes = (match, rowData, isShore) => {
  const pId = get(rowData, 'row.original.personId', null)
  const pTypeCode = get(rowData, 'row.original.personCode', null)
  if (pId && pTypeCode) {
    if (isShore && pTypeCode === PERSON_CREW_ID) {
      return null
    }
    return `${match.path.substring(
      0,
      match.path.substring(1).indexOf('/') + 1
    )}/${PERSON_TYPES_ROUTE[pTypeCode]}/${pId}`
  }
  return null
}

export const formatPhoneNumber = ({ countryCode, number } = {}) => {
  if (!number) return ''
  if (!countryCode) return number
  return `${countryCode}-${number}`
}

export const maskPhoneNumber = (
  phoneValue,
  shouldUnMask = false,
  maskOptions = { showStart: 3, showEnd: 0 }
) => {
  if (!phoneValue || shouldUnMask) return phoneValue || ''

  return String(phoneValue)
    .split(',')
    .map(phone => {
      const trimmed = phone.trim()
      const hyphenIndex = trimmed.indexOf('-')
      if (hyphenIndex === -1) {
        return maskString(trimmed, shouldUnMask, maskOptions)
      }
      const countryCode = trimmed.slice(0, hyphenIndex)
      const number = String(trimmed.slice(hyphenIndex + 1).trim())
      const maskedNumber = maskString(number, shouldUnMask, maskOptions)
      return `${countryCode}-${maskedNumber}`
    })
    .join(', ')
}

export const maskString = (
  value,
  shouldMask = false,
  { showStart = 3, showEnd = 0, maskChar = '*', isEmail = false } = {}
) => {
  if (!value || shouldMask) return value

  if (isEmail) {
    const trimmed = String(value).trim()
    if (!trimmed) return ''

    const atIndex = trimmed.indexOf('@')
    const localPart = trimmed.slice(0, atIndex)
    const domain = trimmed.slice(atIndex)
    const isShortLocalPart = localPart.length <= 2
    const emailShowStart = isShortLocalPart ? 0 : 2
    const emailMaskLength = isShortLocalPart ? 2 : 3
    const maskSource = isShortLocalPart
      ? localPart.padEnd(emailMaskLength, 'x')
      : `${localPart.slice(0, emailShowStart)}${'x'.repeat(emailMaskLength)}`

    return `${maskString(maskSource, false, {
      showStart: emailShowStart,
      showEnd: 0,
      maskChar
    })}${domain}`
  }

  if (typeof value !== 'string') return value

  const len = value.length

  if (showStart + showEnd >= len) return value

  const start = value.slice(0, showStart)
  const end = value.slice(len - showEnd)
  const maskedSection = maskChar.repeat(len - showStart - showEnd)

  return `${start}${maskedSection}${end}`
}

export const maskBasedOnPersonType = (
  personTypeCode,
  { shouldUnMaskedSailor, shouldUnMaskedCrew, shouldUnMaskedVisitor }
) => {
  let shouldMask = shouldUnMaskedSailor
  if (personTypeCode === PERSON_CREW_ID) {
    shouldMask = shouldUnMaskedCrew
  } else if (personTypeCode === PERSON_VISITOR_ID) {
    shouldMask = shouldUnMaskedVisitor
  }
  return shouldMask
}

export const formatDocNumber = (
  identifications,
  shouldUnMaskedPerson,
  personTypeCode = PERSON_VISITOR_ID
) => {
  const docNumber =
    maskString(get(identifications, 'number', null), shouldUnMaskedPerson) ||
    'NA'
  const docTypeCode =
    get(identifications, 'documentTypeCode', null) ||
    get(identifications, 'typeCode', null)
  if (
    personTypeCode === PERSON_RESERVATION_GUEST_ID ||
    personTypeCode === PERSON_CREW_ID
  ) {
    return docNumber
  } else if (personTypeCode === PERSON_VISITOR_ID) {
    const issueCountryCode = get(identifications, 'issueCountryCode', null)
    const issueStateCode = get(identifications, 'issueStateCode', null)
    const visaTypeCode =
      get(identifications, 'visaTypeCode', null) ||
      get(identifications, 'subTypeCode', null)

    let idNumberPrefix = ''
    if (docTypeCode === docTypes.dl) {
      idNumberPrefix = issueStateCode
    } else if (
      docTypeCode === docTypes.passport ||
      docTypeCode === docTypes.govissid
    ) {
      idNumberPrefix = issueCountryCode
    } else if (docTypeCode === docTypes.usVisa) {
      idNumberPrefix = visaTypeCode
    }
    return idNumberPrefix ? `${idNumberPrefix}-${docNumber}` : docNumber
  }
}

export const isVisitorActive = visitor => get(visitor, 'isActive') !== false

export const calculateDocumentSizeInBytes = dataUrl => {
  if (!dataUrl || typeof dataUrl !== 'string') return 0
  const comma = dataUrl.indexOf(',')
  if (comma < 0) return 0
  return Math.floor(((dataUrl.length - comma - 1) * 3) / 4)
}

export const detectFileType = async url => {
  try {
    const res = await fetch(url)
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    const buffer = await res?.arrayBuffer()
    const bytes = new Uint8Array(buffer)?.subarray(0, 4)
    const header = Array?.from(bytes)
      ?.map(b => b?.toString(16)?.padStart(2, '0'))
      ?.join('')

    if (header?.startsWith('25504446')) return 'pdf'
    return 'unknown'
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('File detection failed:', err)
    return 'unknown'
  }
}
